(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mindvey-custom-tee"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initStudios = () => {
    const sections = document.querySelectorAll('.mv-tee-app:not([data-mv-tee-ready])');
    sections.forEach((root) => {
      root.setAttribute('data-mv-tee-ready', 'true');
      const sectionId = root.dataset.sectionId;
      const variantsEl = document.querySelector(`[data-product-variants-${sectionId}]`);
      let variants = [];
      if (root.dataset.productVariants) {
        try { variants = JSON.parse(root.dataset.productVariants); } catch (e) { variants = []; }
      }
      if ((!variants || !variants.length) && variantsEl) {
        try { variants = JSON.parse(variantsEl.textContent || '[]'); } catch (e) { variants = []; }
      }
      const variantIdInput = root.querySelector('[data-variant-id]');
      const addButton = root.querySelector('[data-add-button]');
      const priceNodes = [...root.querySelectorAll('[data-tee-price]')];
      const formStatus = root.querySelector('[data-form-status]');
      const quantityInput = root.querySelector('[data-custom-tee-quantity]');
      const initialVariant = variants.find((item) => String(item.id) === String(variantIdInput?.value));
      let currentVariantPriceCents = Number(initialVariant?.price || 0);
      const locale = root.dataset.locale || 'en';
      const currency = root.dataset.currency || 'USD';
      const productTitle = root.dataset.productTitle || '';
      const productHandle = root.dataset.productHandle || '';
      let productOptionNames = [];
      try { productOptionNames = JSON.parse(root.dataset.productOptions || '[]'); } catch (e) { productOptionNames = []; }
      const variantTitleField = root.querySelector('[data-variant-title-field]');
      const variantOptionsField = root.querySelector('[data-variant-options-field]');
      const canvasWrap = root.querySelector('[data-canvas-wrap]');
      const editorStage = root.querySelector('[data-editor-stage]');
      const canvas = root.querySelector('[data-canvas]');
      const zoomReadout = root.querySelector('[data-zoom-readout]');
      const imageOpacity = root.querySelector('[data-image-opacity]');
      const imageOpacityReadout = root.querySelector('[data-image-opacity-readout]');
      const textFont = root.querySelector('[data-text-font]');
      const fontPicker = root.querySelector('[data-font-picker]');
      const fontTrigger = root.querySelector('[data-font-trigger]');
      const fontMenu = root.querySelector('[data-font-menu]');
      const textColor = root.querySelector('[data-text-color]');
      const textOpacity = root.querySelector('[data-text-opacity]');
      const textOpacityReadout = root.querySelector('[data-text-opacity-readout]');
      const form = root.querySelector('form');

      let backImagesByColor = {};
      try {
        const raw = root.dataset.backImagesByColor || '{}';
        backImagesByColor = raw ? JSON.parse(raw) : {};
      } catch (e) {
        backImagesByColor = {};
      }

      const state = {};
      let selectedLayer = null;
      let layerSeq = 0;

      const areaSlabsRaw = String(root.dataset.areaSlabs || '').trim();
      const areaSlabs = (areaSlabsRaw ? areaSlabsRaw.split('\n') : []).map((line) => {
        const parts = String(line).split(':');
        const max = Number((parts[0] || '').trim());
        const surcharge = Number((parts[1] || '').trim());
        if (!Number.isFinite(max) || !Number.isFinite(surcharge)) return null;
        return { max, surcharge };
      }).filter(Boolean).sort((a, b) => a.max - b.max);
      const hqPercent = Number(root.dataset.hqPercent || 10) || 10;
      const configuredZoneWidthCm = Number(root.dataset.zoneWidthCm || 35) || 35;
      const configuredZoneHeightCm = Number(root.dataset.zoneHeightCm || 40) || 40;
      const productionDpi = Math.max(72, Number(root.dataset.productionDpi || 300) || 300);
      const productionRenderedDpi = {};
      const printBottomMarginCm = Math.max(0, Number(root.dataset.printBottomMarginCm || 10) || 0);
      const printTopCm = Math.max(0, Number(root.dataset.printTopCm || 10) || 10);
      const printWidthPercent = Math.max(1, Math.min(100, Number(root.dataset.printWidthPercent || 72) || 72));
      const printHeightPercent = Math.max(1, Math.min(100, Number(root.dataset.printHeightPercent || 55) || 55));

      // The product/mockup image contains a small amount of transparent/white
      // breathing room around the actual shirt silhouette. Keep the production
      // print zone mapped to the visible garment, not to that image whitespace.
      // These are fractions of the rendered garment image used by the studio.
      // The bottom anchor is the visible T-shirt hem.
      const GARMENT_IMAGE_TOP_PCT = 5.5;
      const GARMENT_IMAGE_BOTTOM_PCT = 92.5;

      // Garment measurements are laid-flat measurements from the supplied size chart.
      // These values define the physical coordinate system used by production.
      const SIZE_CHART = {
        'S':    { width_cm: 45.72, length_cm: 71.12, sleeve_center_back_cm: 40.96 },
        'M':    { width_cm: 50.80, length_cm: 73.66, sleeve_center_back_cm: 45.09 },
        'L':    { width_cm: 55.88, length_cm: 76.20, sleeve_center_back_cm: 48.26 },
        'XL':   { width_cm: 60.96, length_cm: 78.74, sleeve_center_back_cm: 52.07 },
        '2XL':  { width_cm: 66.04, length_cm: 81.28, sleeve_center_back_cm: 55.88 },
        '3XL':  { width_cm: 71.12, length_cm: 83.82, sleeve_center_back_cm: 59.06 },
        '4XL':  { width_cm: 76.20, length_cm: 86.36, sleeve_center_back_cm: 62.87 },
        '5XL':  { width_cm: 81.28, length_cm: 88.90, sleeve_center_back_cm: 66.04 }
      };
      const normalizeSize = (value) => String(value || '').trim().toUpperCase().replace(/\s+/g, '');
      const getSelectedSize = (variant) => {
        const options = variant?.options || [];
        const named = options.find((value, index) => /size/i.test(productOptionNames[index] || ''));
        const candidate = named || options.find((value) => SIZE_CHART[normalizeSize(value)]);
        const normalized = normalizeSize(candidate);
        return SIZE_CHART[normalized] ? normalized : null;
      };
      const getGarmentProfile = (variant) => {
        const size = getSelectedSize(variant);
        if (size) return { size, ...SIZE_CHART[size], source: 'Mindvey size chart' };
        return { size: null, width_cm: configuredZoneWidthCm, length_cm: configuredZoneHeightCm, sleeve_center_back_cm: null, source: 'configured fallback' };
      };
      let garmentProfile = getGarmentProfile(initialVariant);
      let printZoneProfile = null;
      let zoneWidthCm = configuredZoneWidthCm;
      let zoneHeightCm = configuredZoneHeightCm;

      // The editor shows ONE common print zone for every shirt size (same place on the mockup).
      // The zone is defined once as a share of a reference shirt (editor_reference_size, default 5XL = the largest size, so the width cap is never exceeded)
      // and then converted to real centimetres for whichever size is selected. So the editor never
      // moves, but the cm sizes and coordinates in the order details follow the selected shirt size.
      const referenceSizeKey = SIZE_CHART[normalizeSize(root.dataset.referenceSize)] ? normalizeSize(root.dataset.referenceSize) : '5XL';
      const calculatePrintZone = (profile) => {
        const ref = SIZE_CHART[referenceSizeKey];
        const refWidth = Math.min(configuredZoneWidthCm, ref.width_cm * (printWidthPercent / 100));
        const refTop = Math.min(Math.max(0, printTopCm), ref.length_cm);
        const fracW = refWidth / ref.width_cm;
        const fracTop = refTop / ref.length_cm;
        const refBottom = Math.min(printBottomMarginCm, Math.max(0, ref.length_cm - refTop - 1));
        const fracBottom = refBottom / ref.length_cm;
        const fracH = (ref.length_cm - refTop - refBottom) / ref.length_cm;

        const width = profile.width_cm * fracW;
        const top = profile.length_cm * fracTop;
        const height = profile.length_cm * fracH;
        const bottom = profile.length_cm * fracBottom;
        const left = (profile.width_cm - width) / 2;

        // Map into the visible shirt silhouette of the mockup image (same for every size).
        const visualTopPct = GARMENT_IMAGE_TOP_PCT / 100;
        const visualBottomPct = GARMENT_IMAGE_BOTTOM_PCT / 100;
        const visualSpanPct = Math.max(0.01, visualBottomPct - visualTopPct);
        const topPctOfCanvas = visualTopPct + fracTop * visualSpanPct;
        const heightPctOfCanvas = Math.max(0, fracH * visualSpanPct);
        return {
          x_cm: left, y_cm: top, width_cm: width, height_cm: height,
          center_x_cm: left + width / 2, center_y_cm: top + height / 2,
          right_cm: profile.width_cm - left - width,
          bottom_cm: bottom,
          canvas_top_pct: topPctOfCanvas * 100,
          canvas_height_pct: heightPctOfCanvas * 100
        };
      };
      const applyPrintZone = (profile = garmentProfile) => {
        printZoneProfile = calculatePrintZone(profile);
        zoneWidthCm = printZoneProfile.width_cm;
        zoneHeightCm = printZoneProfile.height_cm;
        const zones = root.querySelectorAll('[data-zone]');
        const guides = root.querySelectorAll('[data-side] .mv-tee-guides__zone');
        const grids = root.querySelectorAll('[data-side] .mv-tee-guides__grid');
        const leftPct = (printZoneProfile.x_cm / profile.width_cm) * 100;
        const topPct = Number.isFinite(printZoneProfile.canvas_top_pct)
          ? printZoneProfile.canvas_top_pct
          : (printZoneProfile.y_cm / profile.length_cm) * 100;
        const widthPct = (printZoneProfile.width_cm / profile.width_cm) * 100;
        const heightPct = Number.isFinite(printZoneProfile.canvas_height_pct)
          ? printZoneProfile.canvas_height_pct
          : (printZoneProfile.height_cm / profile.length_cm) * 100;
        zones.forEach((zone) => {
          zone.style.left = `${leftPct}%`;
          zone.style.top = `${topPct}%`;
          zone.style.width = `${widthPct}%`;
          zone.style.height = `${heightPct}%`;
          zone.dataset.productionZone = 'true';
          zone.dataset.productionLabel = `${zone.dataset.zone || 'front'}`.toUpperCase() + ' PRINT ZONE';
        });
        guides.forEach((guide) => {
          guide.style.left = `${leftPct}%`;
          guide.style.top = `${topPct}%`;
          guide.style.width = `${widthPct}%`;
          guide.style.height = `${heightPct}%`;
          guide.style.inset = 'auto';
        });
        grids.forEach((grid) => {
          grid.style.left = `${leftPct}%`;
          grid.style.top = `${topPct}%`;
          grid.style.width = `${widthPct}%`;
          grid.style.height = `${heightPct}%`;
          grid.style.inset = 'auto';
        });
        root.dataset.garmentSize = profile.size || '';
      };
      applyPrintZone();

      const enableAreaSlab = root.dataset.enableAreaSlab !== 'false';
      const enableHq = root.dataset.enableHq !== 'false';

      let areaProductVariants = [];
      try {
        const parsed = JSON.parse(root.dataset.areaProductVariants || '[]');
        if (Array.isArray(parsed)) areaProductVariants = parsed;
      } catch (e) {
        areaProductVariants = [];
      }
      let hqProductVariants = [];
      try {
        const parsed = JSON.parse(root.dataset.hqProductVariants || '[]');
        if (Array.isArray(parsed)) hqProductVariants = parsed;
      } catch (e) {
        hqProductVariants = [];
      }

      const enable3d = root.getAttribute('data-enable-3d') === 'true';
      const model3dUrl = (root.getAttribute('data-model-3d-url') || '').trim();
      const model3dUv = (root.getAttribute('data-model-3d-uv') || '0.12,0.20,0.38,0.48').trim();
      const model3dBackUv = (root.getAttribute('data-model-3d-back-uv') || '0.62,0.18,0.89,0.48').trim();
      const model3dTextureSize = Math.min(4096, Math.max(512, Math.round(Number(root.getAttribute('data-model-3d-texture-size')) || 2048)));
      const model3dAutoRotate = root.getAttribute('data-model-3d-auto-rotate') === 'true';
      const model3dCameraMode = root.getAttribute('data-model-3d-camera') || 'horizontal';

      const qualityField = root.querySelector('[data-quality-field]');
      const slabField = root.querySelector('[data-slab-field]');
      const areaField = root.querySelector('[data-area-field]');
      const slabDisplay = root.querySelector('[data-slab-display]');
      const priceInfo = root.querySelector('[data-price-info]');
      const priceBreakdown = root.querySelector('[data-price-breakdown]');
      const qualityButtons = [...root.querySelectorAll('[data-quality]')];
      let currentQuality = 'standard';
      let currentSlab = { index: 1, surcharge: 0, area: 0 };
      let zoom = 100;

      const money = (cents) => {
        try { return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(Number(cents || 0) / 100); }
        catch (e) { return String(Number(cents || 0) / 100); }
      };

      const libraryRaw = String(root.dataset.library || '').trim();
      const libraryItems = libraryRaw.split('\n').map((line) => line.trim()).filter(Boolean).map((line) => {
        const [url, ...rest] = line.split('|');
        return { url: url.trim(), label: rest.join('|').trim() || 'Graphic' };
      }).filter((item) => item.url);
      const libraryEl = root.querySelector('[data-library]');
      const librarySrcSet = new Set();

      const renderLibrary = () => {
        if (!libraryEl) return;
        libraryEl.innerHTML = '';
        if (!libraryItems.length) {
          const empty = document.createElement('div');
          empty.className = 'mv-tee-library__empty';
          empty.textContent = 'COMING SOON';
          libraryEl.appendChild(empty);
          return;
        }
        libraryItems.forEach((item) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'mv-tee-library__item';
          btn.title = item.label;
          btn.setAttribute('aria-label', `Add ${item.label}`);
          const img = document.createElement('img');
          img.src = item.url;
          img.alt = item.label;
          img.loading = 'lazy';
          img.crossOrigin = 'anonymous';
          btn.appendChild(img);
          btn.addEventListener('click', () => {
            const key = ensureLayer(activeSide, 'image', { src: item.url, name: item.label });
            if (!key) return;
            librarySrcSet.add(item.url);
            setSide(activeSide);
            deselect();
            layerForKey(key)?.classList.add('is-selected');
            selectedLayer = key;
            syncEditorControls();
            updatePricing();
            syncDesignManifest();
            if (formStatus) formStatus.textContent = `${item.label} added to ${activeSide}. Move it on the shirt to position it.`;
          });
          libraryEl.appendChild(btn);
        });
      };

      const selected = [];
      const uploadedFiles = { front: [], back: [] };
      const uploadedLogoFiles = { front: null, back: null };
      const logoKeys = { front: null, back: null };
      const LOGO_MAX_SCALE = 40; // max logo size (% of the normal artwork box) - keeps a logo small. Raise to allow bigger logos.
      const LOGO_MODE_TEXT_MAX_SCALE = 100; // max text size in logo-only mode (100 = default small size)
      const LOGO_MODE_TEXT_MAX_CHARS = 12;  // max characters of the single text in logo-only mode
      let printMode = 'any'; // 'front' | 'back' | 'both' | 'logo' | 'any' - read from the selected variant
      root.querySelectorAll('[data-product-option]').forEach((btn) => {
        const idx = Number(btn.dataset.optionIndex);
        if (btn.classList.contains('is-active')) selected[idx] = btn.dataset.value;
      });
      const updateOptionAvailability = () => {
        root.querySelectorAll('[data-product-option]').forEach((btn) => {
          const idx = Number(btn.dataset.optionIndex);
          const value = btn.dataset.value;
          const possible = variants.some((item) => item.available && item.options.every((optionValue, optionIndex) => {
            if (optionIndex === idx) return optionValue === value;
            return !selected[optionIndex] || optionValue === selected[optionIndex];
          }));
          btn.disabled = !possible;
          btn.classList.toggle('is-sold-out', !possible);
          btn.setAttribute('aria-disabled', String(!possible));
        });
      };

      const getSlabForArea = (areaCm2) => {
        if (!enableAreaSlab) return { index: 1, surcharge: 0, area: areaCm2 };
        if (!areaSlabs.length) return { index: 1, surcharge: 0, area: areaCm2 };
        for (let i = 0; i < areaSlabs.length; i += 1) {
          if (areaCm2 <= areaSlabs[i].max) return { index: i + 1, surcharge: areaSlabs[i].surcharge, area: areaCm2 };
        }
        const last = areaSlabs[areaSlabs.length - 1];
        return { index: areaSlabs.length, surcharge: last.surcharge, area: areaCm2 };
      };

      const computeCurrentAreaCm2 = () => {
        if (!canvas) return 0;
        const keys = Object.keys(state);
        if (!keys.length) return 0;
        const canvasRect = canvas.getBoundingClientRect();
        if (!canvasRect.width || !canvasRect.height) return 0;
        const cmPerPxX = zoneWidthCm / canvasRect.width;
        const cmPerPxY = zoneHeightCm / canvasRect.height;
        const activeLayers = Object.entries(state).filter(([key]) => key.startsWith(`${activeSide}-`));
        if (!activeLayers.length) return 0;
        let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        activeLayers.forEach(([key, d]) => {
          const layer = layerForKey(key);
          if (!layer) return;
          const layerRect = layer.getBoundingClientRect();
          const layerWcm = layerRect.width * cmPerPxX;
          const layerHcm = layerRect.height * cmPerPxY;
          const centerXcm = (d.x / 100) * zoneWidthCm;
          const centerYcm = (d.y / 100) * zoneHeightCm;
          const halfW = layerWcm / 2;
          const halfH = layerHcm / 2;
          minX = Math.min(minX, centerXcm - halfW);
          maxX = Math.max(maxX, centerXcm + halfW);
          minY = Math.min(minY, centerYcm - halfH);
          maxY = Math.max(maxY, centerYcm + halfH);
        });
        if (!Number.isFinite(minX)) return 0;
        const wcm = maxX - minX;
        const hcm = maxY - minY;
        return Math.max(0, wcm * hcm);
      };

      const findAreaVariant = (slabIndex) => {
        if (!enableAreaSlab) return null;
        if (!areaProductVariants.length) return null;
        const wanted = `Slab ${slabIndex}`;
        return areaProductVariants.find((v) => v.title === wanted || (v.options || []).includes(wanted)) || null;
      };

      const findHqVariant = (slabIndex) => {
        if (!enableHq) return null;
        if (!hqProductVariants.length) return null;
        const wanted = `Slab ${slabIndex}`;
        return hqProductVariants.find((v) => v.title === wanted || (v.options || []).includes(wanted)) || null;
      };

      const updatePricing = () => {
        const areaCm2 = computeCurrentAreaCm2();
        const slab = getSlabForArea(areaCm2);
        currentSlab = slab;
        const slabLabel = `Slab ${slab.index}`;
        const slabSurchargeCents = enableAreaSlab ? Math.round(slab.surcharge * 100) : 0;
        const slabbedCents = currentVariantPriceCents + slabSurchargeCents;
        const hqSurchargeCents = (enableHq && currentQuality === 'high') ? Math.round(slabbedCents * hqPercent / 100) : 0;
        const perUnitCents = slabbedCents + hqSurchargeCents;
        const qty = Math.max(1, Math.floor(Number(quantityInput?.value) || 1));
        const totalCents = perUnitCents * qty;

        priceNodes.forEach((n) => { n.textContent = money(totalCents); });

        if (enableAreaSlab && priceInfo && slabDisplay) {
          priceInfo.hidden = false;
          slabDisplay.textContent = areaCm2 > 0
            ? `${Math.round(areaCm2)} cm² → ${slabLabel} (+${money(slabSurchargeCents)})`
            : `No design yet → ${slabLabel}`;
        }

        if (slabField) slabField.value = (enableAreaSlab && areaCm2 > 0) ? slabLabel : '';
        if (areaField) areaField.value = (enableAreaSlab && areaCm2 > 0) ? String(Math.round(areaCm2)) : '';
        if (qualityField) qualityField.value = (enableHq && currentQuality === 'high') ? `High quality (${hqPercent}%)` : 'Standard';

        if (priceBreakdown) {
          const rows = [
            `<div class="mv-tee-price-breakdown__row"><span>Base (${selected.join(' / ') || '—'})</span><strong>${money(currentVariantPriceCents)}</strong></div>`
          ];
          if (enableAreaSlab) {
            rows.push(`<div class="mv-tee-price-breakdown__row"><span>Print area (${slabLabel})</span><strong>+${money(slabSurchargeCents)}</strong></div>`);
          }
          rows.push(`<div class="mv-tee-price-breakdown__row mv-tee-price-breakdown__row--subtotal"><span>Subtotal</span><strong>${money(slabbedCents)}</strong></div>`);
          if (enableHq && currentQuality === 'high') {
            rows.push(`<div class="mv-tee-price-breakdown__row"><span>Print quality (High quality ${hqPercent}%)</span><strong>+${money(hqSurchargeCents)}</strong></div>`);
          }
          rows.push(`<div class="mv-tee-price-breakdown__row mv-tee-price-breakdown__row--subtotal"><span>Per unit</span><strong>${money(perUnitCents)}</strong></div>`);
          rows.push(`<div class="mv-tee-price-breakdown__row"><span>Quantity</span><strong>${qty}</strong></div>`);
          rows.push(`<div class="mv-tee-price-breakdown__row mv-tee-price-breakdown__row--total"><span>Total</span><strong>${money(totalCents)}</strong></div>`);
          priceBreakdown.innerHTML = rows.join('');
        }
      };

      const updateEditorTotal = () => {
        updatePricing();
        syncDesignManifest();
      };

      const updateVariant = () => {
        const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
        if (!variant) {
          if (addButton) { addButton.disabled = true; addButton.textContent = 'Unavailable'; }
          if (formStatus) formStatus.textContent = 'That color/size combination is unavailable.';
          updateOptionAvailability();
          return;
        }
        variantIdInput.value = variant.id;
        if (variantTitleField) variantTitleField.value = variant.title || '';
        if (variantOptionsField) variantOptionsField.value = (variant.options || []).map((value, index) => {
          const name = productOptionNames[index] || `Option ${index + 1}`;
          return `${name}: ${value}`;
        }).join(' | ');
        currentVariantPriceCents = Number(variant.price || 0);
        garmentProfile = getGarmentProfile(variant);
        applyPrintZone(garmentProfile);
        updateEditorTotal();
        try { applyPrintMode(variant); } catch (err) { console.error('Print option update failed', err); }

        // Colour option position (falls back to the first option). Used so a variant without its own image
        // (e.g. "Logo only") still shows the shirt in the chosen colour.
        let colorIdx = productOptionNames.findIndex((n) => /colou?r/i.test(n || ''));
        if (colorIdx < 0) colorIdx = 0;
        const imgOf = (v) => v?.featured_image?.src || v?.featured_image?.url || '';
        const variantFrontSrc = imgOf(variant)
          || imgOf(variants.find((v) => v.options?.[colorIdx] === variant.options?.[colorIdx] && imgOf(v)))
          || '';
        if (variantFrontSrc) {
          const frontGarment = root.querySelector('[data-side="front"] .mv-tee-garment');
          if (frontGarment && frontGarment.tagName === 'IMG') frontGarment.src = variantFrontSrc;
        }

        const variantColor = (variant.options && variant.options[colorIdx]) ? String(variant.options[colorIdx]).trim() : '';
        const variantBackSrc = variantColor ? (backImagesByColor[variantColor] || '') : '';
        if (variantBackSrc) {
          const backGarment = root.querySelector('[data-side="back"] .mv-tee-garment');
          if (backGarment && backGarment.tagName === 'IMG') backGarment.src = variantBackSrc;
        }

        if (addButton) { addButton.disabled = !variant.available; addButton.textContent = variant.available ? 'Add to cart' : 'Sold out'; }
        if (formStatus) formStatus.textContent = variant.available ? '' : 'This variant is currently sold out. Please choose another available option.';
        updateOptionAvailability();
      };
      root.querySelectorAll('[data-product-option]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const idx = Number(btn.dataset.optionIndex);
          root.querySelectorAll(`[data-product-option][data-option-index="${idx}"]`).forEach((b) => b.classList.toggle('is-active', b === btn));
          selected[idx] = btn.dataset.value;
          updateVariant();
        });
      });

      qualityButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          currentQuality = btn.dataset.quality === 'high' ? 'high' : 'standard';
          qualityButtons.forEach((b) => {
            const active = b === btn;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-pressed', String(active));
          });
          updatePricing();
          syncDesignManifest();
        });
      });

      const railBtns = [...root.querySelectorAll('[data-tab]')];
      const panels = [...root.querySelectorAll('[data-panel]')];
      railBtns.forEach((btn) => btn.addEventListener('click', () => {
        railBtns.forEach((b) => b.classList.toggle('is-active', b === btn));
        panels.forEach((p) => p.classList.toggle('is-active', p.dataset.panel === btn.dataset.tab));
        if (btn.dataset.tab === 'order') updatePricing();
      }));

      let activeSide = 'front';
      const sideViews = [...root.querySelectorAll('[data-side]')];
      const viewBtns = [...root.querySelectorAll('[data-view]')];
      root.querySelectorAll('.mv-tee-garment').forEach((img) => {
        img.style.display = 'block';
        img.style.visibility = 'visible';
        img.style.opacity = '1';
      });

      const logoSide = () => Object.keys(state).find((k) => state[k].role === 'logo')?.split('-')[0] || null;
      const syncTextAvailability = () => {
        const logo = logoSide();
        root.querySelectorAll('[data-text-for]').forEach((t) => {
          const side = t.dataset.textFor.split('-')[0];
          const locked = ((printMode === 'front' || printMode === 'back') && side !== printMode)
            || (printMode === 'logo' && side !== logo);
          t.hidden = locked || side !== activeSide;
          const input = t.querySelector('[data-text-input]');
          if (input) {
            input.disabled = locked;
            if (locked) input.value = '';
          }
        });
      };
      const setSide = (side) => {
        activeSide = side;
        sideViews.forEach((v) => v.hidden = v.dataset.side !== side);
        viewBtns.forEach((b) => b.classList.toggle('is-active', b.dataset.view === side));
        root.querySelectorAll('[data-upload-for]').forEach((u) => {
          const [uploadSide, uploadType] = u.dataset.uploadFor.split('-');
          const locked = (printMode === 'front' || printMode === 'back') && uploadSide !== printMode;
          u.hidden = locked || uploadSide !== side || (printMode === 'logo' && uploadType === 'image');
          const input = u.querySelector('input[type="file"]');
          if (input) input.disabled = u.hidden;
        });
        syncTextAvailability();
        deselect();
      };
      viewBtns.forEach((btn) => btn.addEventListener('click', () => setSide(btn.dataset.view)));

      let panX = 0;
      let panY = 0;
      let panMode = false;
      let panOnly = false;
      const panOnlyButton = root.querySelector('[data-pan-only]');

      const setPanOnly = (enabled) => {
        panOnly = !!enabled;
        root.classList.toggle('is-pan-only', panOnly);
        panOnlyButton?.classList.toggle('is-active', panOnly);
        panOnlyButton?.setAttribute('aria-pressed', String(panOnly));
        if (panOnlyButton) panOnlyButton.textContent = panOnly ? 'Editing locked' : 'Pan only';
        if (panOnly) deselect();
      };
      panOnlyButton?.addEventListener('click', () => setPanOnly(!panOnly));
      let panStartX = 0;
      let panStartY = 0;
      let panOriginX = 0;
      let panOriginY = 0;

      const clampPan = () => {
        if (!editorStage || !canvasWrap || !canvas) return;
        if (zoom <= 100) { panX = 0; panY = 0; return; }
        const scale = zoom / 100;
        // Measure the real, un-transformed layout so the limits stay correct even when the canvas is
        // taller than the visible area (mobile) and is not centred inside the stage.
        const prevTransform = editorStage.style.transform;
        editorStage.style.transform = 'none';
        const w = canvasWrap.getBoundingClientRect();
        const c = canvas.getBoundingClientRect();
        const st = editorStage.getBoundingClientRect();
        editorStage.style.transform = prevTransform;
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const margin = 18;
        const bottomMargin = isMobile ? 64 : margin; // keep the canvas bottom clear of the Front/Back + zoom controls
        const limit = (wMin, wMax, cMin, cMax, stMin, stMax, minMargin, maxMargin) => {
          const o = (stMin + stMax) / 2; // transform-origin = stage centre
          const lo0 = o + (cMin - o) * scale, hi0 = o + (cMax - o) * scale;
          if (hi0 - lo0 > wMax - wMin) return [wMax - maxMargin - hi0, wMin + minMargin - lo0];
          return [wMin - lo0, wMax - hi0];
        };
        const [minX, maxX] = limit(w.left, w.right, c.left, c.right, st.left, st.right, margin, margin);
        const [minY, maxY] = limit(w.top, w.bottom, c.top, c.bottom, st.top, st.bottom, margin, bottomMargin);
        panX = Math.max(minX, Math.min(maxX, panX));
        panY = Math.max(minY, Math.min(maxY, panY));
      };

      const applyStageTransform = () => {
        if (!editorStage) return;
        clampPan();
        editorStage.style.transform = `translate3d(${panX}px, ${panY}px, 0) scale(${zoom / 100})`;
        editorStage.classList.toggle('is-pannable', zoom > 100);
      };

      const setZoom = (value) => {
        zoom = Math.max(60, Math.min(200, value));
        if (zoom <= 100) { panX = 0; panY = 0; }
        applyStageTransform();
        if (zoomReadout) zoomReadout.textContent = `${Math.round(zoom)}%`;
      };

      root.querySelector('[data-zoom-in]')?.addEventListener('click', () => setZoom(zoom + 10));
      root.querySelector('[data-zoom-out]')?.addEventListener('click', () => setZoom(zoom - 10));
      root.querySelector('[data-zoom-reset]')?.addEventListener('click', () => setZoom(100));

      // Capture touch gestures before artwork handlers so a second finger zooms the canvas.
      const canvasTouches = new Map();
      let pinch = null;
      let pinchSession = false;
      const touchPair = () => [...canvasTouches.values()].slice(0, 2);
      const beginPinch = () => {
        const [a, b] = touchPair();
        if (!a || !b || !editorStage) return;
        const rect = editorStage.getBoundingClientRect();
        const centerX = (a.x + b.x) / 2, centerY = (a.y + b.y) / 2;
        const originX = rect.left + rect.width / 2 - panX;
        const originY = rect.top + rect.height / 2 - panY;
        pinch = {
          distance: Math.max(1, Math.hypot(b.x - a.x, b.y - a.y)), zoom,
          originX, originY,
          anchorX: (centerX - originX - panX) / (zoom / 100),
          anchorY: (centerY - originY - panY) / (zoom / 100)
        };
      };
      editorStage?.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'touch' || e.target.closest('button, input, select, textarea, a')) return;
        canvasTouches.set(e.pointerId, { x: e.clientX, y: e.clientY, target: e.target });
        if (canvasTouches.size < 2 && !pinchSession) {
          editorStage.setPointerCapture?.(e.pointerId);
          return;
        }
        e.preventDefault();
        e.stopImmediatePropagation();
        if (!pinchSession) {
          // Finish an in-progress single-finger edit before taking over its pointer.
          for (const [id, touch] of canvasTouches) {
            if (id !== e.pointerId) touch.target.dispatchEvent(new PointerEvent('pointercancel', {
              bubbles: true, pointerId: id, pointerType: 'touch'
            }));
          }
          pinchSession = true;
          panMode = false;
          editorStage.classList.remove('is-panning');
        }
        for (const id of canvasTouches.keys()) editorStage.setPointerCapture?.(id);
        beginPinch();
      }, { capture: true, passive: false });
      editorStage?.addEventListener('pointermove', (e) => {
        const touch = canvasTouches.get(e.pointerId);
        if (!touch) return;
        touch.x = e.clientX; touch.y = e.clientY;
        if (!pinchSession) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        if (!pinch || canvasTouches.size < 2) return;
        const [a, b] = touchPair();
        const nextZoom = Math.max(60, Math.min(200,
          pinch.zoom * Math.hypot(b.x - a.x, b.y - a.y) / pinch.distance));
        panX = (a.x + b.x) / 2 - pinch.originX - pinch.anchorX * nextZoom / 100;
        panY = (a.y + b.y) / 2 - pinch.originY - pinch.anchorY * nextZoom / 100;
        setZoom(nextZoom);
      }, { capture: true, passive: false });
      const endCanvasTouch = (e) => {
        // Ignore our synthetic cancellation of the previous artwork gesture.
        if (!e.isTrusted || !canvasTouches.has(e.pointerId)) return;
        canvasTouches.delete(e.pointerId);
        if (!pinchSession) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        if (editorStage.hasPointerCapture?.(e.pointerId)) editorStage.releasePointerCapture(e.pointerId);
        pinch = null;
        if (canvasTouches.size >= 2) beginPinch();
        // Keep the remaining finger from unexpectedly dragging artwork after a pinch.
        if (canvasTouches.size === 0) pinchSession = false;
      };
      editorStage?.addEventListener('pointerup', endCanvasTouch, { capture: true });
      editorStage?.addEventListener('pointercancel', endCanvasTouch, { capture: true });
      window.addEventListener('blur', () => {
        canvasTouches.clear(); pinch = null; pinchSession = false; panMode = false;
        editorStage?.classList.remove('is-panning');
      });

      editorStage?.addEventListener('pointerdown', (e) => {
        if (zoom <= 100) return;
        if (!panOnly && e.target.closest('.mv-tee-layer, button, input, select, textarea, a')) return;
        if (e.target.closest('button, input, select, textarea, a')) return;
        panMode = true;
        panStartX = e.clientX;
        panStartY = e.clientY;
        panOriginX = panX;
        panOriginY = panY;
        editorStage.classList.add('is-panning');
        editorStage.setPointerCapture?.(e.pointerId);
        e.preventDefault();
        e.stopPropagation();
      });

      editorStage?.addEventListener('pointermove', (e) => {
        if (!panMode) return;
        panX = panOriginX + (e.clientX - panStartX);
        panY = panOriginY + (e.clientY - panStartY);
        applyStageTransform();
        e.preventDefault();
      });

      const stopPan = (e) => {
        if (!panMode) return;
        panMode = false;
        editorStage?.classList.remove('is-panning');
        if (e?.pointerId != null) editorStage?.releasePointerCapture?.(e.pointerId);
      };
      editorStage?.addEventListener('pointerup', stopPan);
      editorStage?.addEventListener('pointercancel', stopPan);
      editorStage?.addEventListener('lostpointercapture', () => {
        panMode = false;
        editorStage?.classList.remove('is-panning');
      });

      canvasWrap?.addEventListener('wheel', (e) => {
        const overCanvas = e.target.closest('.mv-tee-canvas') !== null;
        if (!overCanvas) return;
        e.preventDefault();
        setZoom(zoom + (e.deltaY < 0 ? 10 : -10));
      }, { passive: false });

      const defaults = (kind) => kind === 'text'
        ? { x: 50, y: 50, scale: 100, rot: 0, opacity: 100, font: 'Arial, sans-serif', color: '#111111', text: '', bold: false, italic: false }
        : { x: 50, y: 50, scale: 100, rot: 0, opacity: 100, src: '', name: '' };
      const makeKey = (side, kind) => `${side}-${kind}-${++layerSeq}`;
      const layerForKey = (key) => {
        const [side] = key.split('-');
        return zoneFor(side)?.querySelector(`[data-key="${key}"]`);
      };
      const zoneFor = (side) => root.querySelector(`[data-zone="${side}"]`);
      const selectionBar = root.querySelector('[data-selection-bar]');
      const selectionLabel = root.querySelector('[data-selection-label]');
      const clearSelectionButton = root.querySelector('[data-clear-selection]');
      const layerLabel = (key) => {
        if (!key || !state[key]) return 'No edit selected';
        if (state[key].role === 'logo') return 'Logo selected';
        return key.includes('-image-') ? 'Artwork selected' : 'Text selected';
      };
      const updateSelectionBar = () => {
        const has = !!(selectedLayer && state[selectedLayer]);
        selectionLabel && (selectionLabel.textContent = has ? layerLabel(selectedLayer) : 'No edit selected');
        selectionBar?.classList.toggle('has-selection', has);
        if (clearSelectionButton) clearSelectionButton.hidden = !has;
      };
      const deselect = () => {
        root.querySelectorAll('.mv-tee-layer.is-selected').forEach((l) => l.classList.remove('is-selected'));
        selectedLayer = null;
        updateSelectionBar();
      };
      const syncEditorControls = () => {
        updateSelectionBar();
        const bd = selectedLayer && state[selectedLayer]?.bold;
        const it = selectedLayer && state[selectedLayer]?.italic;
        root.querySelector('[data-text-bold]')?.classList.toggle('is-active', !!bd);
        root.querySelector('[data-text-bold]')?.setAttribute('aria-pressed', String(!!bd));
        root.querySelector('[data-text-italic]')?.classList.toggle('is-active', !!it);
        root.querySelector('[data-text-italic]')?.setAttribute('aria-pressed', String(!!it));
        if (!selectedLayer || !state[selectedLayer]) return;
        const d = state[selectedLayer];
        // Update ALL rotation readouts to reflect the selected layer's rotation
        const rotVal = `${Math.round(d.rot || 0)}°`;
        root.querySelectorAll('[data-rotate-readout]').forEach(el => { el.textContent = rotVal; });
        if (selectedLayer.includes('-image-')) {
          if (imageOpacity) imageOpacity.value = d.opacity ?? 100;
          if (imageOpacityReadout) imageOpacityReadout.textContent = `${Math.round(d.opacity ?? 100)}%`;
        } else if (selectedLayer.includes('-text-')) {
          if (textFont) setFontChoice(d.font || 'Arial, sans-serif');
          if (textColor) textColor.value = d.color || '#111111';
          if (textOpacity) textOpacity.value = d.opacity ?? 100;
          if (textOpacityReadout) textOpacityReadout.textContent = `${Math.round(d.opacity ?? 100)}%`;
          const input = root.querySelector(`[data-text-input="${activeSide}"]`);
          if (input) input.value = d.text || '';
        }
      };
      // Keep the selection frame hugging the visible artwork (the layer box itself stays 60% of the zone for export maths).
      const fitLayerFrame = (layer) => {
        const frame = layer.querySelector('.mv-tee-frame');
        const img = layer.querySelector('img');
        if (!frame || !img) return;
        const lw = layer.offsetWidth, lh = layer.offsetHeight, nw = img.naturalWidth, nh = img.naturalHeight;
        if (!lw || !lh || !nw || !nh) return;
        const fit = Math.min(lw / nw, lh / nh);
        const dw = nw * fit, dh = nh * fit;
        frame.style.inset = 'auto';
        frame.style.left = ((lw - dw) / 2) + 'px';
        frame.style.top = ((lh - dh) / 2) + 'px';
        frame.style.width = dw + 'px';
        frame.style.height = dh + 'px';
      };
      // Clip only the visual content; selection outlines and handles stay outside the zone.
      const clipLayerContent = (layer, d) => {
        fitLayerFrame(layer);
        const zone = layer.parentElement;
        const content = layer.querySelector('img, [data-text-content]');
        if (!zone || !content || !zone.clientWidth || !zone.clientHeight) return;
        const angle = (Number(d.rot) || 0) * Math.PI / 180;
        const cos = Math.cos(angle), sin = Math.sin(angle);
        const scale = layer.dataset.kind === 'image' ? Number(d.scale) / 100 : 1;
        if (!(scale > 0)) return;
        const w = zone.clientWidth, h = zone.clientHeight;
        const cx = Number(d.x) / 100 * w, cy = Number(d.y) / 100 * h;
        const box = getComputedStyle(layer);
        const lw = parseFloat(box.width) + (box.boxSizing === 'border-box' ? 0 : parseFloat(box.paddingLeft) + parseFloat(box.paddingRight));
        const lh = parseFloat(box.height) + (box.boxSizing === 'border-box' ? 0 : parseFloat(box.paddingTop) + parseFloat(box.paddingBottom));
        const points = [[0, 0], [w, 0], [w, h], [0, h]].map(([x, y]) => {
          const dx = x - cx, dy = y - cy;
          return `${(dx * cos + dy * sin) / scale + lw / 2 - content.offsetLeft}px ${(dy * cos - dx * sin) / scale + lh / 2 - content.offsetTop}px`;
        });
        content.style.clipPath = `polygon(${points.join(',')})`;
      };
      const clipObserver = new ResizeObserver((entries) => {
        entries.forEach(({ target }) => {
          if (target.dataset.key) {
            if (state[target.dataset.key]) clipLayerContent(target, state[target.dataset.key]);
          } else {
            target.querySelectorAll('.mv-tee-layer').forEach((layer) => {
              if (state[layer.dataset.key]) clipLayerContent(layer, state[layer.dataset.key]);
            });
          }
        });
      });
      ['front', 'back'].forEach((side) => { const zone = zoneFor(side); if (zone) clipObserver.observe(zone); });
      const removeLayer = (key) => {
        const wasLogo = state[key]?.role === 'logo';
        const layer = layerForKey(key);
        if (layer) { clipObserver.unobserve(layer); layer.remove(); }
        delete state[key];
        if (wasLogo && printMode === 'logo') {
          Object.keys(state).filter((k) => k.includes('-text-')).forEach(removeLayer);
          root.querySelectorAll('[data-text-input]').forEach((input) => { input.value = ''; });
          syncTextAvailability();
        }
        if (selectedLayer === key) deselect();
        syncEditorControls();
        updatePricing();
        syncDesignManifest();
      };
      const renderLayer = (key) => {
        const layer = layerForKey(key), d = state[key];
        if (!layer || !d) return;
        const kind = layer.dataset.kind;
        const opacity = Math.max(0, Math.min(100, d.opacity ?? 100)) / 100;
        layer.style.left = d.x + '%';
        layer.style.top = d.y + '%';
        layer.style.opacity = 1; // layer container stays fully opaque (handles visible)
        layer.style.transform = `translate(-50%,-50%) rotate(${d.rot}deg)${kind === 'image' ? ` scale(${d.scale / 100})` : ''}`;
        if (kind === 'image') {
          layer.style.setProperty('--mv-inv', String(100 / Math.max(1, Number(d.scale) || 100)));
          layer.style.width = '60%'; layer.style.height = '60%';
          const img = layer.querySelector('img'); 
          if (img) {
            img.style.opacity = opacity; // only artwork gets opacity
            if (d.src && img.src !== d.src) img.src = d.src;
          }
        } else {
          layer.style.fontSize = `${16 * d.scale / 100}px`;
          layer.style.fontFamily = d.font || 'Arial, sans-serif';
          layer.style.fontWeight = d.bold ? '700' : '400';
          layer.style.fontStyle = d.italic ? 'italic' : 'normal';
          layer.style.fontSynthesis = 'weight style';
          layer.style.color = d.color || '#111111';
          const textNode = layer.querySelector('[data-text-content]');
          if (textNode) {
            textNode.textContent = d.text || '';
            textNode.style.opacity = opacity; // only text content gets opacity
            textNode.style.fontWeight = d.bold ? '700' : '400';
            textNode.style.fontStyle = d.italic ? 'italic' : 'normal';
            textNode.style.fontSynthesis = 'weight style';
          }
        }
        clipLayerContent(layer, d);
        if (selectedLayer === key || !selectedLayer) updatePricing();
      };
      const ensureLayer = (side, kind, data = {}) => {
        const key = makeKey(side, kind);
        const zone = zoneFor(side); if (!zone) return null;
        const layer = document.createElement('div');
        layer.className = `mv-tee-layer${kind === 'text' ? ' is-text' : ''}`;
        layer.dataset.kind = kind; layer.dataset.key = key;
        layer.innerHTML = kind === 'image'
          ? `<div class="mv-tee-frame"><div class="mv-tee-frame__stem"></div><div class="mv-tee-h mv-tee-h--rot" data-h="rot" title="Drag to rotate (hold Shift to snap)">⟳</div><div class="mv-tee-h mv-tee-h--corner mv-tee-h--tl" data-h="res"></div><div class="mv-tee-h mv-tee-h--corner mv-tee-h--tr" data-h="res"></div><div class="mv-tee-h mv-tee-h--corner mv-tee-h--bl" data-h="res"></div><div class="mv-tee-h mv-tee-h--corner mv-tee-h--br" data-h="res"></div><div class="mv-tee-h mv-tee-h--del" data-h="del" title="Remove">×</div></div><img alt="Uploaded artwork" crossorigin="anonymous">`
          : `<div class="mv-tee-handle mv-tee-handle--del" data-h="del">×</div><div class="mv-tee-handle mv-tee-handle--rot" data-h="rot">⟳</div><div class="mv-tee-handle mv-tee-handle--res" data-h="res">⇲</div><span data-text-content></span>`;
        if (kind === 'image') layer.querySelector('img')?.addEventListener('load', () => fitLayerFrame(layer));
        zone.appendChild(layer);
        state[key] = Object.assign(defaults(kind), data);
        clipObserver.observe(layer);
        wireLayer(layer, key);
        renderLayer(key);
        return key;
      };
      const wireLayer = (layer, key) => {
        let mode = null;
        let startX = 0, startY = 0;
        let startVal = null, startYVal = null;
        let startZoneWidth = 1, startZoneHeight = 1;
        let moved = false;
        let ctrX = 0, ctrY = 0, startAngle = 0, startDist = 1;
        const [side] = key.split('-');
        layer.style.touchAction = 'none';
        const layerCenter = () => { const r = layer.getBoundingClientRect(); ctrX = r.left + r.width / 2; ctrY = r.top + r.height / 2; };

        layer.addEventListener('pointerdown', (e) => {
          if (e.target.dataset.h) return;
          if (panOnly) return;
          e.preventDefault();
          e.stopPropagation();
          const zone = zoneFor(side);
          if (!zone) return;
          const r = zone.getBoundingClientRect();
          deselect();
          layer.classList.add('is-selected');
          selectedLayer = key;
          layer.tabIndex = -1;
          layer.focus({ preventScroll: true });
          syncEditorControls();
          mode = 'move';
          moved = false;
          startX = e.clientX;
          startY = e.clientY;
          startVal = Number(state[key].x) || 50;
          startYVal = Number(state[key].y) || 50;
          startZoneWidth = Math.max(1, r.width);
          startZoneHeight = Math.max(1, r.height);
          layer.setPointerCapture?.(e.pointerId);
        });

        layer.querySelector('[data-h="del"]').addEventListener('pointerdown', (e) => {
          if (panOnly) return;
          e.preventDefault();
          e.stopPropagation();
          removeLayer(key);
        });

        layer.querySelector('[data-h="rot"]').addEventListener('pointerdown', (e) => {
          if (panOnly) return;
          e.preventDefault();
          e.stopPropagation();
          mode = 'rotate';
          startX = e.clientX;
          startVal = Number(state[key].rot) || 0;
          layerCenter();
          startAngle = Math.atan2(e.clientY - ctrY, e.clientX - ctrX) * 180 / Math.PI;
          layer.setPointerCapture?.(e.pointerId);
        });

        layer.querySelectorAll('[data-h="res"]').forEach((resHandle) => resHandle.addEventListener('pointerdown', (e) => {
          if (panOnly) return;
          e.preventDefault();
          e.stopPropagation();
          mode = 'resize';
          startX = e.clientX;
          startVal = Number(state[key].scale) || 100;
          layerCenter();
          startDist = Math.max(4, Math.hypot(e.clientX - ctrX, e.clientY - ctrY));
          layer.setPointerCapture?.(e.pointerId);
        }));

        layer.addEventListener('pointermove', (e) => {
          if (!mode) return;
          e.preventDefault();
          const d = state[key];
          if (!d) return;

          if (mode === 'move') {
            const dx = e.clientX - startX;
            const dy = e.clientY - startY;
            if (!moved && Math.hypot(dx, dy) < 2) return;
            moved = true;

            // Move by pointer delta instead of snapping the artwork's center
            // to the cursor. This preserves the exact grab point and keeps
            // dragging smooth even when the layer is scaled or rotated.
            const deltaXPercent = (dx / startZoneWidth) * 100;
            const deltaYPercent = (dy / startZoneHeight) * 100;
            d.x = Math.min(99, Math.max(1, startVal + deltaXPercent));
            d.y = Math.min(99, Math.max(1, startYVal + deltaYPercent));
          } else if (mode === 'rotate') {
            if (layer.dataset.kind === 'image') {
              // Word-style: the layer turns to follow the pointer around its centre (Shift snaps to 15°).
              const angle = Math.atan2(e.clientY - ctrY, e.clientX - ctrX) * 180 / Math.PI;
              let rot = startVal + (angle - startAngle);
              if (e.shiftKey) rot = Math.round(rot / 15) * 15;
              d.rot = ((Math.round(rot) % 360) + 360) % 360;
            } else {
              d.rot = Math.round(startVal + (e.clientX - startX));
            }
          } else if (mode === 'resize') {
            if (layer.dataset.kind === 'image') {
              // Word-style corner drag: proportional resize from the centre, based on pointer distance.
              const dist = Math.hypot(e.clientX - ctrX, e.clientY - ctrY);
              const maxScale = d.role === 'logo' ? LOGO_MAX_SCALE : 600;
              d.scale = Math.min(maxScale, Math.max(10, startVal * (dist / startDist)));
            } else {
              d.scale = Math.min(printMode === 'logo' ? LOGO_MODE_TEXT_MAX_SCALE : 600, Math.max(10, startVal + (e.clientX - startX)));
            }
          }
          renderLayer(key);
        });

        const stop = (e) => {
          if (!mode) return;
          if (mode === 'move' || mode === 'resize' || mode === 'rotate') {
            syncDesignManifest();
            syncEditorControls();
          }
          if (e?.pointerId != null) layer.releasePointerCapture?.(e.pointerId);
          mode = null;
          moved = false;
        };
        layer.addEventListener('pointerup', stop);
        layer.addEventListener('pointercancel', stop);
        layer.addEventListener('lostpointercapture', () => { mode = null; moved = false; });
      };
      root.querySelector('.mv-tee-app__canvas-wrap').addEventListener('pointerdown', e => { if (!e.target.closest('.mv-tee-layer')) deselect(); });
      clearSelectionButton?.addEventListener('click', () => deselect());

      const enforceLogoText = () => {
        const side = logoSide();
        let kept = false;
        Object.keys(state).filter((k) => k.includes('-text-')).forEach((key) => {
          if (!side || !key.startsWith(`${side}-`) || kept) { removeLayer(key); return; }
          kept = true;
          state[key].text = String(state[key].text || '').slice(0, LOGO_MODE_TEXT_MAX_CHARS);
          state[key].scale = Math.min(state[key].scale, LOGO_MODE_TEXT_MAX_SCALE);
          renderLayer(key);
        });
        root.querySelectorAll('[data-text-input]').forEach((input) => {
          const key = Object.keys(state).find((k) => k.startsWith(`${input.dataset.textInput}-text-`));
          input.value = key ? state[key].text : '';
        });
        syncTextAvailability();
      };
      ['front','back'].forEach((side) => {
        const fileInput=root.querySelector(`[data-art-input="${side}"]`);
        fileInput?.addEventListener('change', () => {
          [...(fileInput.files || [])].forEach(file => {
            const isImage = file && (file.type.startsWith('image/') || /\.(png|jpe?g|webp|svg)$/i.test(file.name || ''));
            if (!isImage) {
              if (formStatus) formStatus.textContent = `${file?.name || 'That file'} is not a supported image.`;
              return;
            }
            uploadedFiles[side].push(file);
            const reader = new FileReader();
            reader.onload = () => {
              const src = String(reader.result || '');
              if (!src) return;
              const key = ensureLayer(side, 'image', { src, name: file.name });
              const layer = layerForKey(key);
              const img = layer?.querySelector('img');
              if (img) {
                img.src = src;
                img.dataset.originalSrc = src;
              }
              renderLayer(key);
              setSide(side);
              deselect();
              layer?.classList.add('is-selected');
              selectedLayer = key;
              syncEditorControls();
              const prop = root.querySelector(`[data-upload-property="${side}"]`);
              if (prop) prop.value = [...(prop.value ? prop.value.split(', ') : []), file.name].join(', ');
              updatePricing();
              syncDesignManifest();
              if (formStatus) formStatus.textContent = 'Artwork added. You can move, resize or rotate it in the editor.';
            };
            reader.onerror = () => {
              if (formStatus) formStatus.textContent = `Could not read ${file.name}. Please choose the image again.`;
            };
            reader.readAsDataURL(file);
          });
          fileInput.value = '';
        });

        const logoInput = root.querySelector(`[data-logo-input="${side}"]`);
        logoInput?.addEventListener('change', () => {
          const file = logoInput.files?.[0];
          logoInput.value = '';
          if (!file) return;
          const isImage = file.type.startsWith('image/') || /\.(png|jpe?g|webp|svg)$/i.test(file.name || '');
          if (!isImage) {
            if (formStatus) formStatus.textContent = `${file.name || 'That file'} is not a supported image.`;
            return;
          }
          uploadedLogoFiles[side] = file;
          const reader = new FileReader();
          reader.onload = () => {
            const src = String(reader.result || '');
            if (!src) return;
            // Logo only = ONE logo in total: a new upload replaces the earlier one (on either side).
            const sidesToClear = printMode === 'logo' ? ['front', 'back'] : [side];
            sidesToClear.forEach((s) => {
              const existingKey = logoKeys[s];
              if (existingKey) { layerForKey(existingKey)?.remove(); delete state[existingKey]; logoKeys[s] = null; }
              if (s !== side) {
                uploadedLogoFiles[s] = null;
                const otherProp = root.querySelector(`[data-logo-upload-property="${s}"]`);
                if (otherProp) otherProp.value = '';
              }
            });
            const key = ensureLayer(side, 'image', { src, name: file.name, role: 'logo', x: 22, y: 20, scale: Math.min(28, LOGO_MAX_SCALE) });
            logoKeys[side] = key;
            if (printMode === 'logo') enforceLogoText();
            const layer = layerForKey(key);
            const img = layer?.querySelector('img');
            if (img) { img.src = src; img.dataset.originalSrc = src; }
            renderLayer(key);
            setSide(side);
            deselect();
            layer?.classList.add('is-selected');
            selectedLayer = key;
            syncEditorControls();
            const prop = root.querySelector(`[data-logo-upload-property="${side}"]`);
            if (prop) prop.value = file.name;
            updatePricing();
            syncDesignManifest();
            if (formStatus) formStatus.textContent = 'Logo added to its placement spot — drag to fine-tune.';
          };
          reader.onerror = () => {
            if (formStatus) formStatus.textContent = `Could not read ${file.name}. Please choose the image again.`;
          };
          reader.readAsDataURL(file);
        });

        const textInput=root.querySelector(`[data-text-input="${side}"]`);
        textInput?.addEventListener('input',()=>{
          if (((printMode === 'front' || printMode === 'back') && side !== printMode)
              || (printMode === 'logo' && side !== logoSide())) { textInput.value = ''; return; }
          if (printMode === 'logo') textInput.value = textInput.value.slice(0, LOGO_MODE_TEXT_MAX_CHARS);
          let key=selectedLayer?.includes(`-${side}-`) ? selectedLayer : selectedLayer?.startsWith(`${side}-text-`) ? selectedLayer : null;
          if(printMode==='logo'){
            // Logo only: just ONE text in total - reuse it (and drop a copy left on the other side).
            const texts=Object.keys(state).filter((k)=>k.includes('-text-'));
            key=texts.find((k)=>k.startsWith(`${side}-`))||null;
            texts.filter((k)=>k!==key).forEach((k)=>removeLayer(k));
          }
          if(!key){ key=ensureLayer(side,'text'); selectedLayer=key; layerForKey(key)?.classList.add('is-selected'); }
          state[key].text=textInput.value; renderLayer(key); setSide(side); selectedLayer=key; layerForKey(key)?.classList.add('is-selected'); syncEditorControls(); updatePricing(); syncDesignManifest();
        });
      });
      root.querySelector('[data-add-text]')?.addEventListener('click',()=>{
        if(printMode==='logo') return;
        const key=ensureLayer(activeSide,'text',{text:'New text'}); setSide(activeSide); deselect(); layerForKey(key)?.classList.add('is-selected'); selectedLayer=key; syncEditorControls(); updatePricing(); syncDesignManifest(); textInputFor(activeSide)?.focus();
      });
      const textInputFor=(side)=>root.querySelector(`[data-text-input="${side}"]`);
      // ---- Print option (read from the selected variant): front only / back only / front & back / logo only ----
      const detectPrintMode = (variant) => {
        if (!variant) return 'any';
        const text = [...(variant.options || []), variant.title || ''].join(' | ').toLowerCase();
        if (/\blogo\b/.test(text)) return 'logo';
        const hasFront = /\bfront\b/.test(text), hasBack = /\bback\b/.test(text);
        if (hasFront && hasBack) return 'both';
        if (hasFront) return 'front';
        if (hasBack) return 'back';
        return 'any';
      };
      const applyPrintMode = (variant) => {
        const mode = detectPrintMode(variant);
        printMode = mode;
        const lockedSides = mode === 'front' ? ['back'] : mode === 'back' ? ['front'] : [];
        viewBtns.forEach((b) => {
          const locked = lockedSides.includes(b.dataset.view);
          b.disabled = locked;
          b.classList.toggle('is-locked', locked);
          b.setAttribute('aria-disabled', String(locked));
          b.title = locked ? 'Not included in the option you selected' : '';
        });
        let removedSomething = false;
        lockedSides.forEach((s) => {
          Object.keys(state).filter((k) => k.startsWith(`${s}-`)).forEach((k) => { removeLayer(k); removedSomething = true; });
          logoKeys[s] = null; uploadedLogoFiles[s] = null; uploadedFiles[s] = [];
          root.querySelectorAll(`[data-upload-property="${s}"],[data-logo-upload-property="${s}"]`).forEach((p) => { p.value = ''; });
        });
        if (lockedSides.includes(activeSide)) setSide(lockedSides[0] === 'back' ? 'front' : 'back');
        else setSide(activeSide);
        // Logo only: just the logo upload (single logo), no multi-artwork upload.
        const artTab = root.querySelector('[data-tab="image"]');
        const libTab = root.querySelector('[data-tab="library"]');
        if (artTab) artTab.style.display = mode === 'logo' ? 'none' : '';
        if (libTab) libTab.style.display = mode === 'logo' ? 'none' : '';
        const logoNote = root.querySelector('[data-logo-only-note]');
        if (logoNote) logoNote.hidden = mode !== 'logo';
        const textNote = root.querySelector('[data-logo-only-text-note]');
        if (textNote) textNote.hidden = mode !== 'logo';
        const addTextBtn = root.querySelector('[data-add-text]');
        if (addTextBtn) addTextBtn.style.display = mode === 'logo' ? 'none' : '';
        root.querySelectorAll('[data-text-input]').forEach((inp) => {
          inp.maxLength = mode === 'logo' ? LOGO_MODE_TEXT_MAX_CHARS : 60;
          if (mode === 'logo' && inp.value.length > LOGO_MODE_TEXT_MAX_CHARS) inp.value = inp.value.slice(0, LOGO_MODE_TEXT_MAX_CHARS);
        });
        if (mode === 'logo') {
          // Keep one logo when switching from a two-sided print option.
          const logos = Object.keys(state).filter((k) => state[k].role === 'logo');
          const keep = logos.find((k) => k.startsWith(`${activeSide}-`)) || logos[0];
          logos.filter((k) => k !== keep).forEach((k) => {
            const side = k.split('-')[0];
            layerForKey(k)?.remove(); delete state[k];
            logoKeys[side] = null; uploadedLogoFiles[side] = null;
            const prop = root.querySelector(`[data-logo-upload-property="${side}"]`);
            if (prop) prop.value = '';
            removedSomething = true;
          });
          enforceLogoText();
        }
        if (mode === 'logo') {
          Object.keys(state).filter((k) => k.includes('-image-') && state[k].role !== 'logo').forEach((k) => { removeLayer(k); removedSomething = true; });
          uploadedFiles.front = []; uploadedFiles.back = [];
          root.querySelectorAll('[data-upload-property]').forEach((p) => { p.value = ''; });
          if (artTab?.classList.contains('is-active') || libTab?.classList.contains('is-active')) root.querySelector('[data-tab="logo"]')?.click();
        }
        if (removedSomething && formStatus) {
          formStatus.textContent = mode === 'logo'
            ? 'Logo only: artwork uploads, library graphics and extra text were removed - you can add one logo and one text of up to 12 characters on the same side.'
            : `This option prints ${mode} only, so the other side's design was removed.`;
        }
      };
      applyPrintMode(initialVariant);

      root.querySelectorAll('[data-rotate]').forEach(btn=>btn.addEventListener('click',()=>{ if(!selectedLayer||!state[selectedLayer]) return; const delta=Number(btn.dataset.rotate); state[selectedLayer].rot=((state[selectedLayer].rot+delta)%360+360)%360; renderLayer(selectedLayer); syncEditorControls(); updatePricing(); syncDesignManifest(); }));
      root.querySelectorAll('[data-rotate-reset]').forEach(btn=>btn.addEventListener('click',()=>{ if(!selectedLayer||!state[selectedLayer]) return; state[selectedLayer].rot=0; renderLayer(selectedLayer); syncEditorControls(); updatePricing(); syncDesignManifest(); }));
      root.querySelectorAll('[data-rotate-input]').forEach(input=>input.addEventListener('change',()=>{ if(!selectedLayer||!state[selectedLayer]) return; let val=Number(input.value); if(!Number.isFinite(val)) val=0; val=((val%360)+360)%360; state[selectedLayer].rot=val; input.value=val; renderLayer(selectedLayer); syncEditorControls(); updatePricing(); syncDesignManifest(); }));
      root.querySelectorAll('[data-align]').forEach(btn=>btn.addEventListener('click',()=>{ if(!selectedLayer||!state[selectedLayer]) return; const [x,y]=btn.dataset.align.split(',').map(Number); state[selectedLayer].x=x;state[selectedLayer].y=y;renderLayer(selectedLayer); updatePricing(); syncDesignManifest(); }));

      // Keyboard arrow movement for selected layer
      const KEY_STEP = 0.5; // % per arrow press
      const KEY_STEP_FAST = 5; // % per Shift+arrow
      const KEY_STEP_FINE = 0.1; // % per Ctrl/Cmd+arrow
      document.addEventListener('keydown', (e) => {
        if (!selectedLayer || !state[selectedLayer]) return;
        if (panOnly || e.defaultPrevented || !root.getClientRects().length ||
            document.body.classList.contains('mv-tee-preview-open')) return;
        // Ignore if typing in an input
        const active = document.activeElement;
        if (active && (active.tagName === 'INPUT' || active.tagName === 'TEXTAREA' || active.tagName === 'SELECT' || active.isContentEditable)) return;

        if (active?.closest('.mv-tee-app') && !root.contains(active)) return;
        if (e.key === 'Delete' && !e.ctrlKey && !e.metaKey && !e.altKey) {
          e.preventDefault();
          removeLayer(selectedLayer);
          return;
        }
        const d = state[selectedLayer];
        const isShift = e.shiftKey;
        const isCtrl = e.ctrlKey || e.metaKey;
        const step = isShift ? KEY_STEP_FAST : (isCtrl ? KEY_STEP_FINE : KEY_STEP);
        let moved = false;

        switch (e.key) {
          case 'ArrowLeft':  d.x = Math.max(1, Math.min(99, d.x - step)); moved = true; break;
          case 'ArrowRight': d.x = Math.max(1, Math.min(99, d.x + step)); moved = true; break;
          case 'ArrowUp':    d.y = Math.max(1, Math.min(99, d.y - step)); moved = true; break;
          case 'ArrowDown':  d.y = Math.max(1, Math.min(99, d.y + step)); moved = true; break;
          default: return;
        }
        if (moved) {
          e.preventDefault();
          renderLayer(selectedLayer);
          syncEditorControls();
          updatePricing();
          syncDesignManifest();
        }
      });

      imageOpacity?.addEventListener('input', () => {
        if (!selectedLayer || !state[selectedLayer] || !selectedLayer.includes('-image-')) return;
        state[selectedLayer].opacity = Number(imageOpacity.value);
        if (imageOpacityReadout) imageOpacityReadout.textContent = `${state[selectedLayer].opacity}%`;
        renderLayer(selectedLayer);
        syncDesignManifest();
      });
      textOpacity?.addEventListener('input', () => {
        if (!selectedLayer || !state[selectedLayer] || !selectedLayer.includes('-text-')) return;
        state[selectedLayer].opacity = Number(textOpacity.value);
        if (textOpacityReadout) textOpacityReadout.textContent = `${state[selectedLayer].opacity}%`;
        renderLayer(selectedLayer);
        syncDesignManifest();
      });

      const setFontChoice = (value) => {
        if (textFont) textFont.value = value;
        const option = [...(fontMenu?.querySelectorAll('[data-font-value]') || [])].find((b) => b.dataset.fontValue === value);
        if (fontTrigger) {
          fontTrigger.textContent = option?.textContent?.trim() || value.split(',')[0];
          fontTrigger.style.fontFamily = value;
        }
        fontMenu?.querySelectorAll('[data-font-value]').forEach((b) => b.classList.toggle('is-active', b.dataset.fontValue === value));
        const key = selectedLayer && selectedLayer.includes('-text-') ? selectedLayer : null;
        if (key && state[key]) { state[key].font = value; renderLayer(key); syncDesignManifest(); }
      };
      fontTrigger?.addEventListener('click', () => {
        const open = !fontMenu.hidden;
        fontMenu.hidden = open;
        fontTrigger.setAttribute('aria-expanded', String(!open));
      });
      fontMenu?.querySelectorAll('[data-font-value]').forEach((btn) => {
        btn.addEventListener('click', () => {
          setFontChoice(btn.dataset.fontValue);
          fontMenu.hidden = true;
          fontTrigger?.setAttribute('aria-expanded', 'false');
        });
      });
      document.addEventListener('pointerdown', (e) => {
        if (fontPicker && !fontPicker.contains(e.target)) { fontMenu.hidden = true; fontTrigger?.setAttribute('aria-expanded', 'false'); }
      });
      textFont?.addEventListener('change', () => setFontChoice(textFont.value));
      textColor?.addEventListener('input', () => {
        if (!selectedLayer || !state[selectedLayer] || !selectedLayer.includes('-text-')) return;
        state[selectedLayer].color = textColor.value;
        renderLayer(selectedLayer);
        syncDesignManifest();
      });
      const textBold = root.querySelector('[data-text-bold]');
      const textItalic = root.querySelector('[data-text-italic]');
      textBold?.addEventListener('click', () => {
        if (!selectedLayer || !state[selectedLayer] || !selectedLayer.includes('-text-')) return;
        state[selectedLayer].bold = !state[selectedLayer].bold;
        textBold.classList.toggle('is-active', state[selectedLayer].bold);
        textBold.setAttribute('aria-pressed', String(state[selectedLayer].bold));
        renderLayer(selectedLayer);
        syncDesignManifest();
      });
      textItalic?.addEventListener('click', () => {
        if (!selectedLayer || !state[selectedLayer] || !selectedLayer.includes('-text-')) return;
        state[selectedLayer].italic = !state[selectedLayer].italic;
        textItalic.classList.toggle('is-active', state[selectedLayer].italic);
        textItalic.setAttribute('aria-pressed', String(state[selectedLayer].italic));
        renderLayer(selectedLayer);
        syncDesignManifest();
      });
      setZoom(100);

      const normalizeCustomQuantity = () => {
        if (!quantityInput) return 1;
        let quantity = Number.parseInt(quantityInput.value, 10);
        if (!Number.isFinite(quantity) || quantity < 1) quantity = 1;
        quantity = Math.floor(quantity);
        quantityInput.value = String(quantity);
        quantityInput.setAttribute('value', String(quantity));
        return quantity;
      };
      quantityInput?.addEventListener('input', () => { normalizeCustomQuantity(); updateEditorTotal(); });
      quantityInput?.addEventListener('change', () => { normalizeCustomQuantity(); updateEditorTotal(); });

      const designIdField = root.querySelector('[data-design-id-field]');
      const productionSummaryField = root.querySelector('[data-production-summary-field]');
      const fileStash = root.querySelector('[data-file-stash]');
      const designId = `MV-${Date.now().toString(36).toUpperCase()}-${Math.random().toString(36).slice(2,8).toUpperCase()}`;
      if (designIdField) designIdField.value = designId;

      const compactDesign = () => {
        const canvasEl = root.querySelector('[data-canvas]');
        const canvasRect = canvasEl ? canvasEl.getBoundingClientRect() : null;

        const layers = Object.entries(state).map(([key, d]) => {
          const layerEl = layerForKey(key);
          const layerRect = layerEl ? layerEl.getBoundingClientRect() : null;

          let x_cm = null, y_cm = null, print_zone_x_cm = null, print_zone_y_cm = null, width_cm = null, height_cm = null;

          if (printZoneProfile) {
            print_zone_x_cm = (d.x / 100) * zoneWidthCm;
            print_zone_y_cm = (d.y / 100) * zoneHeightCm;
            x_cm = printZoneProfile.x_cm + print_zone_x_cm;
            y_cm = printZoneProfile.y_cm + print_zone_y_cm;
            const sc = Number(d.scale || 100) / 100;
            if (d.src) {
              // Artwork box is 60% of the print zone, fitted by the image's own aspect ratio.
              const img = layerEl?.querySelector('img');
              const boxW = zoneWidthCm * 0.6, boxH = zoneHeightCm * 0.6;
              const nw = img?.naturalWidth || 0, nh = img?.naturalHeight || 0;
              const fit = nw && nh ? Math.min(boxW / nw, boxH / nh) : null;
              width_cm = (fit ? nw * fit : boxW) * sc;
              height_cm = (fit ? nh * fit : boxH) * sc;
            } else {
              // Text is 16px * scale on screen; convert px to cm using any visible print zone.
              const visZone = [...root.querySelectorAll('[data-zone]')].find((z) => z.getBoundingClientRect().width > 0);
              const zr = visZone?.getBoundingClientRect();
              if (zr && zr.width && zr.height) {
                const cmPerPx = zoneWidthCm / zr.width;
                const fontPx = 16 * sc;
                const lines = String(d.text || '').split(/\r?\n/);
                const mctx = document.createElement('canvas').getContext('2d');
                mctx.font = `${d.italic ? 'italic ' : ''}${d.bold ? '700 ' : '400 '}100px ${d.font || 'Arial, sans-serif'}`;
                const widest = Math.max(0, ...lines.map((ln) => mctx.measureText(ln).width));
                width_cm = (widest / 100) * fontPx * cmPerPx;
                height_cm = lines.length * fontPx * 1.15 * cmPerPx;
              }
            }
          }

          return {
            id: key,
            side: key.split('-')[0],
            type: key.split('-')[1],
            role: d.role || (key.includes('-image-') ? 'artwork' : 'text'),
            x: Math.round(d.x * 10) / 10,
            y: Math.round(d.y * 10) / 10,
            scale: Math.round((d.scale || 100) * 10) / 10,
            rot: Math.round(d.rot || 0),
            opacity: Math.round(d.opacity ?? 100),
            x_cm: x_cm != null ? Math.round(x_cm * 100) / 100 : null,
            y_cm: y_cm != null ? Math.round(y_cm * 100) / 100 : null,
            print_zone_x_cm: print_zone_x_cm != null ? Math.round(print_zone_x_cm * 100) / 100 : null,
            print_zone_y_cm: print_zone_y_cm != null ? Math.round(print_zone_y_cm * 100) / 100 : null,
            width_cm: width_cm != null ? Math.round(width_cm * 100) / 100 : null,
            height_cm: height_cm != null ? Math.round(height_cm * 100) / 100 : null,
            text: d.text || '',
            font: d.font || '',
            color: d.color || '',
            bold: !!d.bold,
            italic: !!d.italic,
            name: d.name || '',
            src: (d.src && !String(d.src).startsWith('data:') && !String(d.src).startsWith('blob:'))
              ? String(d.src).split('?')[0]
              : ''
          };
        });

        const variant = variants.find(v => String(v.id) === String(variantIdInput?.value));
        const quantity = Number(form?.querySelector('[name="quantity"]')?.value || 1);
        const notes = form?.querySelector('[name="properties[Custom tee notes]"]')?.value || '';

        return {
          version: 3,
          manifest_type: 'custom_tee_print_production',
          coordinate_system: 'laid_flat_garment_cm',
          production_dpi: productionDpi,
          id: designId,
          created_at: new Date().toISOString(),
          product_id: root.dataset.productId || '',
          product_handle: productHandle,
          product_title: productTitle,
          variant_id: variantIdInput?.value || '',
          variant_title: variant?.title || '',
          variant_options: (variant?.options || []).map((value, index) => ({
            name: productOptionNames[index] || `Option ${index + 1}`,
            value
          })),
          sku: variant?.sku || '',
          quantity,
          notes,
          active_side: activeSide,
          garment: {
            measurement_method: 'laid_flat',
            size: garmentProfile.size,
            width_cm: garmentProfile.width_cm,
            length_cm: garmentProfile.length_cm,
            sleeve_center_back_cm: garmentProfile.sleeve_center_back_cm,
            center_x_cm: Math.round((garmentProfile.width_cm / 2) * 100) / 100
          },
          print_specification: {
            output_type: 'transparent_artwork_only',
            garment_mockup_in_print_file: false,
            include_sleeves: false,
            include_arms: false,
            color_space: 'sRGB',
            background: 'transparent',
            dpi: productionDpi
          },
          print_zone: {
            x_cm: printZoneProfile?.x_cm ?? 0,
            y_cm: printZoneProfile?.y_cm ?? 0,
            width_cm: zoneWidthCm,
            height_cm: zoneHeightCm,
            center_x_cm: printZoneProfile?.center_x_cm ?? (zoneWidthCm / 2),
            center_y_cm: printZoneProfile?.center_y_cm ?? (zoneHeightCm / 2),
            right_cm: printZoneProfile?.right_cm ?? 0,
            bottom_cm: printZoneProfile?.bottom_cm ?? 0,
            reference: 'front/back torso print area only; sleeves and arms excluded'
          },
          editor_zone_px: canvasRect ? {
            width: Math.round(canvasRect.width),
            height: Math.round(canvasRect.height)
          } : null,
          layers,
          slab: currentSlab,
          quality: currentQuality,
          hq_percent: hqPercent,
          area_slab_enabled: enableAreaSlab,
          hq_enabled: enableHq
        };
      };

      const syncDesignManifest = () => {
        const design = compactDesign();
        const frontFiles = uploadedFiles.front.map(file => file.name);
        const backFiles = uploadedFiles.back.map(file => file.name);
        const frontLogoFile = uploadedLogoFiles.front?.name || '';
        const backLogoFile = uploadedLogoFiles.back?.name || '';
        const libraryFiles = [...librarySrcSet].map(url => (url.split('/').pop() || url).split('?')[0]);
        if (productionSummaryField) {
          const frontText = design.layers.filter(layer => layer.side === 'front' && layer.type === 'text').length;
          const backText = design.layers.filter(layer => layer.side === 'back' && layer.type === 'text').length;
          const frontArtwork = frontFiles.length ? frontFiles.join(', ') : 'None';
          const backArtwork = backFiles.length ? backFiles.join(', ') : 'None';
          const libraryFiles = [...librarySrcSet].map(url => (url.split('/').pop() || url).split('?')[0]);

          const dpiFront = productionRenderedDpi.front || productionDpi;
          const dpiBack = productionRenderedDpi.back || productionDpi;
          // Helper: format dimensions
          const fmt = (n) => n != null && Number.isFinite(n) ? Number(n).toFixed(1) : '—';
          const pct = (n) => n != null && Number.isFinite(n) ? `${Number(n).toFixed(1)}%` : '—';
          const deg = (n) => n != null && Number.isFinite(n) ? `${Math.round(n)}°` : '0°';
          const rgbToHex = (c) => {
            if (!c) return '—';
            if (c.startsWith('#')) return c.toUpperCase();
            const m = c.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
            return m ? '#' + [m[1], m[2], m[3]].map(x => parseInt(x).toString(16).padStart(2, '0')).join('').toUpperCase() : c;
          };
          const fontName = (f) => f ? f.split(',')[0].replace(/['"]/g, '').trim() : '—';

          // Layer detail formatter
          const layerLine = (layer, index) => {
            const side = layer.side.toUpperCase();
            const type = layer.type.toUpperCase();
            const role = layer.role || (type === 'IMAGE' ? 'ARTWORK' : 'TEXT');
            const label = role === 'LOGO' ? 'LOGO' 
              : type === 'TEXT' ? `TEXT: "${layer.text.replace(/\n/g, ' ').substring(0, 80)}${layer.text.length > 80 ? '…' : ''}"`
              : `: ${layer.name || (layer.src ? layer.src.split('/').pop().split('?')[0] : 'image')}`;

            // Position in cm for THIS shirt size (laid-flat garment, origin = top-left of the shirt)
            const g = design.garment || {};
            const hasCm = layer.x_cm != null && layer.y_cm != null;
            const hasDim = layer.width_cm != null && layer.height_cm != null;
            const sideOf = (n) => (n < 0 ? 'left' : 'right');
            const posPct = `Zone position: X ${pct(layer.x)} / Y ${pct(layer.y)}`;
            let posCm = '';
            if (hasCm) {
              const off = layer.x_cm - (g.center_x_cm ?? layer.x_cm);
              posCm = ` • Centre: ${fmt(layer.x_cm)} cm from shirt left, ${fmt(layer.y_cm)} cm down from shirt top`
                + ` • ${Math.abs(off) < 0.05 ? 'On shirt centre line' : `${fmt(Math.abs(off))} cm ${sideOf(off)} of centre line`}`;
              if (hasDim) {
                const top = layer.y_cm - layer.height_cm / 2;
                posCm += ` • Top edge: ${fmt(top)} cm below shirt top`
                  + ` • Left edge: ${fmt(layer.x_cm - layer.width_cm / 2)} cm from shirt left`;
              }
            }

            // Dimensions
            const dims = hasDim ? ` • Size: ${fmt(layer.width_cm)} × ${fmt(layer.height_cm)} cm` : '';

            // Rotation
            const rot = layer.rot ? ` • Rotation: ${deg(layer.rot)}` : '';

            // Opacity
            const opacity = (layer.opacity != null && layer.opacity < 100) ? ` • Opacity: ${Math.round(layer.opacity)}%` : '';

            // Text-specific
            const font = layer.font ? ` • Font: ${fontName(layer.font)}${layer.bold ? ' (Bold)' : ''}${layer.italic ? ' (Italic)' : ''}` : '';
            const color = layer.color ? ` • Color: ${rgbToHex(layer.color)}` : '';

            // Source file info
            const srcInfo = layer.src && !layer.src.startsWith('data:') && !layer.src.startsWith('blob:')
              ? ` • Source: ${layer.src.split('/').pop().split('?')[0]}`
              : layer.src ? ` • Source: embedded (data URI)` : '';

            // Z-order hint
            const zOrder = ` • Layer #${index + 1}`;

            return [
              `  ┌─ [${side}] ${label}${zOrder}`,
              `  │  ${posPct}${posCm}${dims}${rot}${opacity}${font}${color}${srcInfo}`,
              `  └─`
            ].join('\n');
          };

          // Artwork file inventory
          const artworkInventory = () => {
            const lines = [];
            const frontImages = design.layers.filter(l => l.side === 'front' && l.type === 'image' && l.role !== 'logo');
            const backImages = design.layers.filter(l => l.side === 'back' && l.type === 'image' && l.role !== 'logo');
            const frontLogos = design.layers.filter(l => l.side === 'front' && l.role === 'logo');
            const backLogos = design.layers.filter(l => l.side === 'back' && l.role === 'logo');
            
            if (frontImages.length) {
              lines.push('  FRONT ARTWORK:');
              frontImages.forEach((l, i) => {
                const name = l.name || (l.src ? l.src.split('/').pop().split('?')[0] : `image-${i+1}`);
                const dims = l.width_cm && l.height_cm ? ` (${fmt(l.width_cm)}×${fmt(l.height_cm)} cm)` : '';
                lines.push(`    ${i+1}. ${name}${dims} — ${pct(l.x)} / ${pct(l.y)} — ${deg(l.rot)} — ${Math.round(l.opacity || 100)}% opacity`);
              });
            }
            if (backImages.length) {
              lines.push('  BACK ARTWORK:');
              backImages.forEach((l, i) => {
                const name = l.name || (l.src ? l.src.split('/').pop().split('?')[0] : `image-${i+1}`);
                const dims = l.width_cm && l.height_cm ? ` (${fmt(l.width_cm)}×${fmt(l.height_cm)} cm)` : '';
                lines.push(`    ${i+1}. ${name}${dims} — ${pct(l.x)} / ${pct(l.y)} — ${deg(l.rot)} — ${Math.round(l.opacity || 100)}% opacity`);
              });
            }
            if (frontLogos.length || backLogos.length) {
              lines.push('  LOGOS:');
              [...frontLogos, ...backLogos].forEach((l, i) => {
                const side = l.side === 'front' ? 'FRONT' : 'BACK';
                const name = l.name || (l.src ? l.src.split('/').pop().split('?')[0] : 'logo');
                const dims = l.width_cm && l.height_cm ? ` (${fmt(l.width_cm)}×${fmt(l.height_cm)} cm)` : '';
                lines.push(`    ${i+1}. [${side}] ${name}${dims} — ${pct(l.x)} / ${pct(l.y)} — ${deg(l.rot)}`);
              });
            }
            if (libraryFiles.length) {
              lines.push('  LIBRARY GRAPHICS USED:');
              libraryFiles.forEach((f, i) => lines.push(`    ${i+1}. ${f}`));
            }
            return lines.length ? lines.join('\n') : '  None';
          };

          // Text layer inventory
          const textInventory = () => {
            const texts = design.layers.filter(l => l.type === 'text');
            if (!texts.length) return '  None';
            const lines = ['  TEXT LAYERS:'];
            texts.forEach((l, i) => {
              const side = l.side.toUpperCase();
              const preview = l.text.replace(/\n/g, ' ').substring(0, 60);
              const font = fontName(l.font);
              const style = [(l.bold ? 'Bold' : ''), (l.italic ? 'Italic' : '')].filter(Boolean).join(', ') || 'Regular';
              const color = rgbToHex(l.color);
              const dims = l.width_cm && l.height_cm ? ` (${fmt(l.width_cm)}×${fmt(l.height_cm)} cm)` : '';
              lines.push(`    ${i+1}. [${side}] "${preview}${l.text.length > 60 ? '…' : ''}"`);
              lines.push(`        Font: ${font} • Style: ${style} • Color: ${color} • Size: ${pct(l.scale)}%${dims}`);
              lines.push(`        Position: ${pct(l.x)} / ${pct(l.y)}${l.x_cm != null ? ` (garment ${fmt(l.x_cm)}, ${fmt(l.y_cm)} cm; print-zone ${fmt(l.print_zone_x_cm)}, ${fmt(l.print_zone_y_cm)} cm)` : ''} • Rotation: ${deg(l.rot)} • Opacity: ${Math.round(l.opacity || 100)}%`);
            });
            return lines.join('\n');
          };

          // Print specification block
          const printSpecs = [
            `GARMENT:              ${design.garment.size || '—'} • ${design.garment.width_cm} cm W × ${design.garment.length_cm} cm L (laid flat)`,
            `PRINT ZONE:           X ${design.print_zone.x_cm} cm / Y ${design.print_zone.y_cm} cm • ${design.print_zone.width_cm} cm W × ${design.print_zone.height_cm} cm H`,
            `PRINT CENTER:         X ${design.print_zone.center_x_cm} cm / Y ${design.print_zone.center_y_cm} cm from garment top-left`,
            `RENDER RESOLUTION:    ${dpiFront === dpiBack ? `${dpiFront} DPI` : `front ${dpiFront} DPI / back ${dpiBack} DPI`} (front ${Math.round(design.print_zone.width_cm/2.54*dpiFront)} × ${Math.round(design.print_zone.height_cm/2.54*dpiFront)} px)`,
            `COLOR SPACE:          sRGB (convert to printer profile in RIP)`,
            `AREA SLAB:            ${enableAreaSlab ? `Slab ${design.slab.index} — ${Math.round(design.slab.area)} cm²` : 'Disabled (flat rate)'}`,
            `QUALITY TIER:         ${(enableHq && design.quality === 'high') ? `High Quality (+${design.hq_percent}% surcharge)` : 'Standard'}`,
            `MAX INK COVERAGE:     Check RIP — large solid areas may need underbase/choke`
          ];

          const placementLines = [];
          const placementSides = ['front','back'];
          placementSides.forEach((side) => {
            const sideLayers = design.layers.filter(layer => layer.side === side && (layer.role === 'artwork' || layer.type === 'text'));
            if (!sideLayers.length) return;
            placementLines.push(`--- ${side.toUpperCase()} PRINT PLACEMENT ---`);
            placementLines.push(`Garment reference: laid-flat ${design.garment.width_cm} cm W × ${design.garment.length_cm} cm L`);
            placementLines.push(`Print zone origin: X ${fmt(design.print_zone.x_cm)} cm / Y ${fmt(design.print_zone.y_cm)} cm from garment top-left`);
            sideLayers.forEach((layer, i) => {
              placementLines.push(`${i + 1}. ${layer.role === 'artwork' ? 'ARTWORK' : 'TEXT'}${layer.name ? ` — ${layer.name}` : ''}`);
              placementLines.push(`   Position from garment top-left: X ${fmt(layer.x_cm)} cm / Y ${fmt(layer.y_cm)} cm`);
              placementLines.push(`   Position inside print zone: X ${fmt(layer.print_zone_x_cm)} cm / Y ${fmt(layer.print_zone_y_cm)} cm`);
              placementLines.push(`   Finished size: ${fmt(layer.width_cm)} cm W × ${fmt(layer.height_cm)} cm H`);
              placementLines.push(`   Rotation: ${deg(layer.rot)} • Opacity: ${Math.round(layer.opacity ?? 100)}%`);
            });
          });

          productionSummaryField.value = [
            '═══════════════════════════════════════════════════════════════',
            '           CUSTOM TEE — PRODUCTION MANIFEST',
            '═══════════════════════════════════════════════════════════════',
            '',
            'PRINT PLACEMENT — PRINTER REFERENCE',
            'Origin: laid-flat garment top-left = X 0.00 cm / Y 0.00 cm',
            'Measure all X/Y values on the physical laid-flat garment.',
            `Artwork output: transparent artwork only • ${productionDpi} DPI • sRGB`,
            ...placementLines,
            '',
            '',
            '┌─ ORDER INFO ────────────────────────────────────────────────',
            `│ Design ID:         ${design.id}`,
            `│ Created:           ${new Date(design.created_at).toLocaleString()}`,
            `│ Product:           ${design.product_title}`,
            `│ Variant:           ${design.variant_title}`,
            `│ SKU:               ${design.sku || '—'}`,
            `│ Quantity:          ${design.quantity}`,
            `│ Customer Notes:    ${design.notes || 'None'}`,
            '└─────────────────────────────────────────────────────────────',
            '',
            '┌─ PRINT SPECIFICATIONS ─────────────────────────────────────',
            ...printSpecs.map(s => `│ ${s}`),
            '└─────────────────────────────────────────────────────────────',
            '',
            '┌─ SOURCE FILE INVENTORY ────────────────────────────────────',
            artworkInventory(),
            '└─────────────────────────────────────────────────────────────',
            '',
            '┌─ TEXT LAYER INVENTORY ─────────────────────────────────────',
            textInventory(),
            '└─────────────────────────────────────────────────────────────',
            '',
            '┌─ COMPLETE LAYER STACK (bottom → top) ──────────────────────',
            ...design.layers.map((layer, i) => layerLine(layer, i)),
            '└─────────────────────────────────────────────────────────────',
            '',
            '┌─ PRODUCTION FILES ATTACHED TO ORDER ───────────────────────',
            `│ • front-final-design-${design.id}.png  (${dpiFront} DPI, ${design.print_zone.width_cm}×${design.print_zone.height_cm} cm, TRANSPARENT ARTWORK ONLY)`,
            `│ • back-final-design-${design.id}.png   (${dpiBack} DPI, ${design.print_zone.width_cm}×${design.print_zone.height_cm} cm, TRANSPARENT ARTWORK ONLY)`,
            `│ • front-final-preview-${design.id}.png  (garment mockup preview)`,
            `│ • back-final-preview-${design.id}.png   (garment mockup preview)`,
            '│ • All uploaded artwork files (original resolution)',
            '│ • This manifest (in _Custom Tee Details line property)',
            '└─────────────────────────────────────────────────────────────',
            '',
            '═══════════════════════════════════════════════════════════════',
            'PRINT CHECKLIST:',
            '☐ Verify front/back renders match layer stack above',
            '☐ Confirm print zone dimensions match garment size',
            '☐ Check text legibility at print size (min 6pt recommended)',
            '☐ Verify color values — convert spot colors if needed',
            '☐ Confirm underbase/white layer for dark garments',
            '☐ Match Design ID on render files to this manifest',
            '═══════════════════════════════════════════════════════════════'
          ].join('\n');
        }
      };

      const attachArtworkFile = (side, file, index, label) => {
        if (!fileStash || !file) return;
        const input = document.createElement('input');
        input.type = 'file';
        input.name = label ? `properties[${label}]` : `properties[${side === 'front' ? 'Front' : 'Back'} artwork ${index}]`;
        input.accept = 'image/png,image/jpeg,image/webp';
        input.hidden = true;
        const transfer = new DataTransfer();
        transfer.items.add(file);
        input.files = transfer.files;
        fileStash.appendChild(input);
      };

      const loadRenderImage = async (src, useCors = true) => {
        if (!src) return null;
        const image = new Image();
        image.decoding = 'async';
        if (useCors && !String(src).startsWith('data:') && !String(src).startsWith('blob:')) image.crossOrigin = 'anonymous';
        image.src = src;
        try {
          if (image.decode) await image.decode();
          else await new Promise((resolve, reject) => { image.onload = resolve; image.onerror = reject; });
          return image;
        } catch (error) {
          return null;
        }
      };

      const loadRemoteRenderImage = async (src) => {
        if (!src || String(src).startsWith('data:') || String(src).startsWith('blob:')) return loadRenderImage(src, false);
        try {
          const response = await fetch(src, { mode: 'cors', credentials: 'omit' });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const blob = await response.blob();
          const objectUrl = URL.createObjectURL(blob);
          const image = await loadRenderImage(objectUrl, false);
          if (image) image.__mvObjectUrl = objectUrl;
          else URL.revokeObjectURL(objectUrl);
          return image;
        } catch (error) {
          return loadRenderImage(src, true);
        }
      };

      const drawContain = (ctx, image, x, y, width, height) => {
        if (!image || !image.naturalWidth || !image.naturalHeight) return;
        const scale = Math.min(width / image.naturalWidth, height / image.naturalHeight);
        const drawW = image.naturalWidth * scale;
        const drawH = image.naturalHeight * scale;
        ctx.drawImage(image, x + (width - drawW) / 2, y + (height - drawH) / 2, drawW, drawH);
      };

      const getLayerMetrics = (side, key, d, outputWidth, outputHeight) => {
        const layer = layerForKey(key);
        const zoneEl = zoneFor(side);
        if (!layer || !zoneEl) return null;
        const zoneRect = zoneEl.getBoundingClientRect();
        const layerStyle = getComputedStyle(layer);
        const scale = Number(d.scale || 100) / 100;
        const baseW = layer.offsetWidth || 0;
        const baseH = layer.offsetHeight || 0;
        const widthPx = kindOfLayer(d) === 'image' ? baseW * scale : baseW;
        const heightPx = kindOfLayer(d) === 'image' ? baseH * scale : baseH;
        const pxPerOutputX = outputWidth / Math.max(1, zoneEl.offsetWidth);
        const pxPerOutputY = outputHeight / Math.max(1, zoneEl.offsetHeight);
        return {
          centerX: (Number(d.x) / 100) * outputWidth,
          centerY: (Number(d.y) / 100) * outputHeight,
          width: Math.max(1, widthPx * pxPerOutputX),
          height: Math.max(1, heightPx * pxPerOutputY),
          fontSize: Math.max(1, parseFloat(layerStyle.fontSize || '16') * pxPerOutputY),
          baseWidth: baseW,
          baseHeight: baseH
        };
      };

      const kindOfLayer = (d) => d?.src ? 'image' : 'text';

      const drawDesignLayers = async (side, ctx, outputWidth, outputHeight) => {
        const sideLayers = Object.entries(state).filter(([key]) => key.startsWith(`${side}-`));
        const zoneEl = zoneFor(side);
        if (!zoneEl) return;
        const zoneRect = zoneEl.getBoundingClientRect();
        for (const [key, d] of sideLayers) {
          if (!d) continue;
          const metrics = getLayerMetrics(side, key, d, outputWidth, outputHeight);
          if (!metrics) continue;
          const opacity = Math.max(0, Math.min(100, Number(d.opacity ?? 100))) / 100;
          ctx.save();
          ctx.translate(metrics.centerX, metrics.centerY);
          ctx.rotate((Number(d.rot || 0) * Math.PI) / 180);
          ctx.globalAlpha = opacity;

          if (d.src) {
            const image = await loadRenderImage(d.src, false);
            if (image) drawContain(ctx, image, -metrics.width / 2, -metrics.height / 2, metrics.width, metrics.height);
          } else if (d.text) {
            ctx.font = `${d.italic ? 'italic ' : ''}${d.bold ? '700 ' : '400 '}${metrics.fontSize}px ${d.font || 'Arial, sans-serif'}`;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillStyle = d.color || '#111111';
            const lines = String(d.text).split(/\r?\n/);
            const lineHeight = metrics.fontSize * 1.15;
            const startY = -((lines.length - 1) * lineHeight) / 2;
            lines.forEach((line, index) => ctx.fillText(line, 0, startY + index * lineHeight));
          }
          ctx.restore();
        }
      };

      const getGarmentImageForSide = async (side) => {
        const garment = root.querySelector(`[data-side="${side}"] .mv-tee-garment`);
        if (!garment) return null;
        const src = garment.currentSrc || garment.src || '';
        return loadRemoteRenderImage(src);
      };

      // The inactive side is hidden (0x0 layout), which made its export blank. Show only the side being
      // rendered while we measure/draw, then restore what the customer was looking at.
      const withSideVisible = async (side, fn) => {
        const previous = sideViews.map((v) => v.hidden);
        sideViews.forEach((v) => { v.hidden = v.dataset.side !== side; });
        await new Promise((r) => requestAnimationFrame(() => r()));
        try { return await fn(); }
        finally { sideViews.forEach((v, i) => { v.hidden = previous[i]; }); }
      };

      const canvasHasInk = (canvas) => {
        const probe = document.createElement('canvas');
        probe.width = 256;
        probe.height = Math.max(1, Math.round(256 * canvas.height / Math.max(1, canvas.width)));
        const pctx = probe.getContext('2d');
        pctx.drawImage(canvas, 0, 0, probe.width, probe.height);
        const data = pctx.getImageData(0, 0, probe.width, probe.height).data;
        for (let i = 3; i < data.length; i += 4) if (data[i] > 0) return true;
        return false;
      };

      // Shopify rejects uploads above ~18 MB. Photo-heavy artwork at full DPI can exceed that as PNG,
      // so we render at the configured DPI first and step the resolution down until the file fits.
      const PRODUCTION_TARGET_BYTES = 16 * 1024 * 1024;
      const MAX_TOTAL_UPLOAD_BYTES = Math.max(4, Number(root.dataset.maxTotalUploadMb || 20) || 20) * 1024 * 1024;
      const PRODUCTION_MIN_DPI = 100;

      const renderProductionSide = async (side, targetBytes = PRODUCTION_TARGET_BYTES) => withSideVisible(side, async () => {
        const sourceCanvas = root.querySelector('[data-canvas]');
        const zoneEl = zoneFor(side);
        if (!sourceCanvas || !zoneEl || !printZoneProfile) return null;
        await document.fonts?.ready;
        const hasLayers = Object.keys(state).some((key) => key.startsWith(`${side}-`) && state[key]);

        // Browsers (iOS Safari especially) fail or return blank canvases above ~16 million pixels.
        const MAX_CANVAS_PIXELS = 16000000;
        const areaIn2 = (zoneWidthCm / 2.54) * (zoneHeightCm / 2.54);
        let dpi = Math.max(PRODUCTION_MIN_DPI, Math.min(productionDpi, Math.floor(Math.sqrt(MAX_CANVAS_PIXELS / Math.max(1, areaIn2)))));
        let blob = null;
        let usedDpi = dpi;
        while (true) {
          const width = Math.max(1, Math.round((zoneWidthCm / 2.54) * dpi));
          const height = Math.max(1, Math.round((zoneHeightCm / 2.54) * dpi));
          const out = document.createElement('canvas');
          out.width = width;
          out.height = height;
          const ctx = out.getContext('2d');
          if (!ctx) return null;
          ctx.clearRect(0, 0, width, height);
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          await drawDesignLayers(side, ctx, width, height);
          if (hasLayers && !canvasHasInk(out)) throw new Error(`The ${side} design could not be rendered. Please try again.`);
          blob = await new Promise(resolve => out.toBlob(resolve, 'image/png'));
          out.width = out.height = 0;
          usedDpi = dpi;
          if (!blob) return null;
          if (blob.size <= targetBytes || dpi <= PRODUCTION_MIN_DPI) break;
          const next = Math.floor(dpi * Math.sqrt(targetBytes / blob.size) * 0.95);
          dpi = Math.max(PRODUCTION_MIN_DPI, Math.min(next, dpi - 20));
        }
        productionRenderedDpi[side] = usedDpi;
        return new File([blob], `${side}-final-design-${designId}.png`, { type: 'image/png', lastModified: Date.now() });
      });

      const renderFinalPreviewSide = async (side) => withSideVisible(side, async () => {
        const sourceCanvas = root.querySelector('[data-canvas]');
        const zoneEl = zoneFor(side);
        const garment = await getGarmentImageForSide(side);
        if (!sourceCanvas || !zoneEl || !garment || !garment.naturalWidth || !garment.naturalHeight) return null;
        await document.fonts?.ready;

        const mockScale = Math.min(1, 1800 / Math.max(1, garment.naturalWidth));
        const width = Math.max(1, Math.round(garment.naturalWidth * mockScale));
        const height = Math.max(1, Math.round(garment.naturalHeight * mockScale));
        const out = document.createElement('canvas');
        out.width = width;
        out.height = height;
        const ctx = out.getContext('2d');
        if (!ctx) return null;
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, width, height);
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(garment, 0, 0, width, height);

        const canvasRect = sourceCanvas.getBoundingClientRect();
        const zoneRect = zoneEl.getBoundingClientRect();
        const scaleX = width / Math.max(1, canvasRect.width);
        const scaleY = height / Math.max(1, canvasRect.height);
        const zoneLeftPx = (zoneRect.left - canvasRect.left) * scaleX;
        const zoneTopPx = (zoneRect.top - canvasRect.top) * scaleY;
        const zoneWidthPx = zoneRect.width * scaleX;
        const zoneHeightPx = zoneRect.height * scaleY;

        // Clip artwork to the exact print zone for the final/mock preview.
        // The garment remains visible; only artwork/text outside the print zone is cut off.
        ctx.save();
        ctx.beginPath();
        ctx.rect(zoneLeftPx, zoneTopPx, zoneWidthPx, zoneHeightPx);
        ctx.clip();

        // Draw the artwork using the exact same print-zone coordinate system as production.
        const sideLayers = Object.entries(state).filter(([key]) => key.startsWith(`${side}-`));
        for (const [key, d] of sideLayers) {
          const layer = layerForKey(key);
          if (!layer || !d) continue;
          const layerStyle = getComputedStyle(layer);
          const scale = Number(d.scale || 100) / 100;
          const baseW = layer.offsetWidth || 1;
          const baseH = layer.offsetHeight || 1;
          const layerW = baseW * scale * (zoneWidthPx / Math.max(1, zoneEl.getBoundingClientRect().width));
          const layerH = baseH * scale * (zoneHeightPx / Math.max(1, zoneEl.getBoundingClientRect().height));
          const centerX = zoneLeftPx + (Number(d.x) / 100) * zoneWidthPx;
          const centerY = zoneTopPx + (Number(d.y) / 100) * zoneHeightPx;
          const opacity = Math.max(0, Math.min(100, Number(d.opacity ?? 100))) / 100;

          ctx.save();
          ctx.translate(centerX, centerY);
          ctx.rotate((Number(d.rot || 0) * Math.PI) / 180);
          ctx.globalAlpha = opacity;
          if (d.src) {
            const image = await loadRenderImage(d.src, false);
            if (image) drawContain(ctx, image, -layerW / 2, -layerH / 2, layerW, layerH);
          } else if (d.text) {
            const fontSize = Math.max(1, parseFloat(layerStyle.fontSize || '16') * scaleX);
            ctx.font = `${d.italic ? 'italic ' : ''}${d.bold ? '700 ' : '400 '}${fontSize}px ${d.font || 'Arial, sans-serif'}`;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillStyle = d.color || '#111111';
            const mockLines = String(d.text).split(/\r?\n/);
            const mockLineH = fontSize * 1.15;
            mockLines.forEach((line, i) => ctx.fillText(line, 0, -((mockLines.length - 1) * mockLineH) / 2 + i * mockLineH));
          }
          ctx.restore();
        }

        // End the print-zone clipping before finishing the preview canvas.
        ctx.restore();

        if (garment.__mvObjectUrl) URL.revokeObjectURL(garment.__mvObjectUrl);
        const blob = await new Promise(resolve => out.toBlob(resolve, 'image/jpeg', 0.92));
        if (!blob) return null;
        return new File([blob], `${side}-mock-preview-${designId}.jpg`, { type: 'image/jpeg', lastModified: Date.now() });
      });

      const attachGeneratedFile = (label, file) => {
        if (!fileStash || !file) return;
        const input = document.createElement('input');
        input.type = 'file';
        input.name = `properties[${label}]`;
        input.accept = file.type || '*/*';
        input.hidden = true;
        const transfer = new DataTransfer();
        transfer.items.add(file);
        input.files = transfer.files;
        fileStash.appendChild(input);
      };

      let isSavingOrder = false;
      form?.addEventListener('submit', async (event) => {
        if (isSavingOrder) return;
        const variant = variants.find(v => String(v.id) === String(variantIdInput?.value));
        if (!variant || !variant.available) {
          event.preventDefault();
          if (formStatus) formStatus.textContent = 'Please choose an available tee variant before adding to cart.';
          return;
        }
        if (!Object.keys(state).length) {
          event.preventDefault();
          if (formStatus) formStatus.textContent = 'Please add at least one image or text to create your custom design.';
          return;
        }

        event.preventDefault();
        isSavingOrder = true;
        if (addButton) addButton.disabled = true;
        if (formStatus) formStatus.textContent = 'Preparing your front and back production images…';

        try {
          fileStash?.querySelectorAll('input[type="file"]').forEach(input => input.remove());

          const finalQuantity = normalizeCustomQuantity();
          if (quantityInput) {
            quantityInput.value = String(finalQuantity);
            quantityInput.setAttribute('value', String(finalQuantity));
          }
          syncDesignManifest();
          if (designIdField) designIdField.value = designId;
          if (variantTitleField) variantTitleField.value = variant.title || '';
          if (variantOptionsField) variantOptionsField.value = (variant.options || []).map((value, index) => `${productOptionNames[index] || `Option ${index + 1}`}: ${value}`).join(' | ');

          // Only four design files go with the order: high-quality front + back print files and the
          // front + back mock previews the customer saw. Individual uploaded artworks are not attached.
          if (formStatus) formStatus.textContent = 'Preparing your mock previews…';
          const frontMock = await renderFinalPreviewSide('front');
          const backMock = await renderFinalPreviewSide('back');
          const FIXED_OVERHEAD_BYTES = 1024 * 1024; // manifest, sheet, form fields
          const mockBytes = (frontMock?.size || 0) + (backMock?.size || 0);
          const finalTarget = Math.max(2 * 1024 * 1024, Math.min(PRODUCTION_TARGET_BYTES, Math.floor((MAX_TOTAL_UPLOAD_BYTES - FIXED_OVERHEAD_BYTES - mockBytes) / 2)));
          if (formStatus) formStatus.textContent = 'Preparing your front and back print files…';
          const frontFinal = await renderProductionSide('front', finalTarget);
          const backFinal = await renderProductionSide('back', finalTarget);
          if (!frontFinal || !backFinal) throw new Error('Unable to render production images');
          attachGeneratedFile('Front final design', frontFinal);
          attachGeneratedFile('Back final design', backFinal);
          if (frontMock) attachGeneratedFile('Front mock preview', frontMock);
          if (backMock) attachGeneratedFile('Back mock preview', backMock);

          syncDesignManifest(); // refreshes the readable hidden _Custom Tee Details with the final sizes

          const teeProps = {};
          form.querySelectorAll('input[type="hidden"][name^="properties["], input[type="text"][name^="properties["], textarea[name^="properties["]').forEach((inp) => {
            const m = inp.name.match(/^properties\[(.+)\]$/);
            if (m && inp.value) teeProps[m[1]] = inp.value;
          });

          // Submit the actual Shopify product form payload so all product fields, variant data,
          // line-item properties, and file inputs are preserved exactly as Shopify expects.
          const teeData = new FormData(form);
          teeData.set('id', String(Number(variant.id)));
          teeData.set('quantity', String(finalQuantity));
          Object.entries(teeProps).forEach(([k, v]) => teeData.set(`properties[${k}]`, v));
          const MAX_FILE_BYTES = 18 * 1024 * 1024;
          fileStash?.querySelectorAll('input[type="file"]').forEach((inp) => {
            const file = inp.files && inp.files[0];
            if (!file) return;
            if (file.size > MAX_FILE_BYTES) throw new Error(`${file.name} is still larger than 18 MB after compression. Please remove or shrink the largest uploaded image and try again.`);
          });

          const readCartError = async (response, fallback) => {
            let detail = '';
            try {
              const raw = await response.text();
              console.error('Cart add failed:', response.status, raw.slice(0, 500));
              try { const e = JSON.parse(raw); detail = e.description || e.message || (typeof e.errors === 'string' ? e.errors : ''); } catch (x) {}
            } catch (x) {}
            if (detail) return detail;
            if (response.status === 413) return 'Your design files are too large to add to the cart. Please use smaller images and try again.';
            return `${fallback} (error ${response.status || 'network'}). Please try again or use smaller images.`;
          };

          if (formStatus) formStatus.textContent = `Uploading design ${designId}…`;
          const teeResponse = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: teeData });
          if (!teeResponse.ok) throw new Error(await readCartError(teeResponse, 'Cart add failed.'));
          let teeLine = null;
          try { teeLine = await teeResponse.json(); } catch (x) {}

          const extraItems = [];
          if (enableAreaSlab && currentSlab.index > 1 && currentSlab.surcharge > 0) {
            const areaVariant = findAreaVariant(currentSlab.index);
            if (areaVariant && areaVariant.id) {
              extraItems.push({
                id: Number(areaVariant.id),
                quantity: finalQuantity,
                properties: {
                  'For design': designId,
                  'Type': 'Print area surcharge',
                  'Slab': `Slab ${currentSlab.index}`,
                  'Area cm2': String(Math.round(currentSlab.area))
                }
              });
            }
          }
          if (enableHq && currentQuality === 'high') {
            const hqVariant = findHqVariant(currentSlab.index);
            if (hqVariant && hqVariant.id) {
              extraItems.push({
                id: Number(hqVariant.id),
                quantity: finalQuantity,
                properties: {
                  'For design': designId,
                  'Type': 'High quality surcharge',
                  'Slab': `Slab ${currentSlab.index}`,
                  'Percent': String(hqPercent)
                }
              });
            }
          }
          if (extraItems.length) {
            const extraResponse = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: extraItems })
            });
            if (!extraResponse.ok) {
              if (teeLine && teeLine.key) {
                try { await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: teeLine.key, quantity: 0 }) }); } catch (x) {}
              }
              throw new Error(await readCartError(extraResponse, 'Cart add failed.'));
            }
          }
          if (formStatus) formStatus.textContent = 'Added to cart.';
          window.location.href = '/cart';
        } catch (error) {
          isSavingOrder = false;
          if (addButton) addButton.disabled = false;
          if (formStatus) formStatus.textContent = error?.message || 'We could not prepare the production images. Please try again.';
          console.error('Custom Tee submit failed:', error);
        }
      });

      const finalPreviewModal = root.querySelector('[data-final-preview-modal]');
      const finalPreviewArt = root.querySelector('[data-final-preview-front]');
      const finalPreviewButton = root.querySelector('[data-final-preview]');
      const finalPreviewConfirm = root.querySelector('[data-final-preview-confirm]');
      const finalPreviewTabs = [...root.querySelectorAll('[data-final-preview-side]')];
      const mv3dPanel = root.querySelector('[data-mv-3d-panel]');
      const mv3dStage = root.querySelector('[data-mv-3d-stage]');
      const mv3dModel = root.querySelector('[data-mv-3d-model]');
      const mv3dComingSoon = root.querySelector('[data-mv-3d-coming-soon]');
      const mv3dLoading = root.querySelector('[data-mv-3d-loading]');
      let finalPreviewPreviousFocus = null;
      let previewClone = null;
      let previewOriginalSide = 'front';
      let previewCanvasSize = null;
      let mv3dLoaded = false;

      const clearPreview = () => {
        if (previewClone?.parentNode) previewClone.parentNode.removeChild(previewClone);
        previewClone = null;
        previewCanvasSize = null;
      };

      // Atlas rectangles use image coordinates: origin at the top-left, matching tee-plain-uv.glb.
      const parseUvRect = (value, fallback) => {
        const parts = String(value || '').split(',').map((s) => Number(s.trim()));
        if (parts.length !== 4 || parts.some((n) => !Number.isFinite(n) || n < 0 || n > 1)
          || parts[2] <= parts[0] || parts[3] <= parts[1]) return fallback;
        return parts;
      };

      const get3dShirtColor = () => {
        const colors = { black: '#171717', white: '#ffffff', 'eucalyptus green': '#7b8c77' };
        try {
          const custom = JSON.parse(root.getAttribute('data-model-3d-colors') || '{}');
          for (const [name, value] of Object.entries(custom)) {
            if (typeof value === 'string' && /^#[0-9a-f]{6}$/i.test(value)) colors[name.trim().toLowerCase()] = value;
          }
        } catch (error) { /* Use the stock colour map if merchant JSON is invalid. */ }
        const colorIndex = productOptionNames.findIndex((name) => /colou?r/i.test(name));
        const name = String(colorIndex >= 0 ? selected[colorIndex] || '' : selected.find((v) => colors[String(v).trim().toLowerCase()]) || '').trim().toLowerCase();
        if (colors[name]) return colors[name];
        return CSS.supports('color', name) ? name : '#ffffff';
      };

      const renderDesignTexture = async () => {
        const size = model3dTextureSize;
        const c = document.createElement('canvas');
        c.width = c.height = size;
        const ctx = c.getContext('2d');
        if (!ctx) throw new Error('Could not create the 3D artwork texture.');
        ctx.fillStyle = get3dShirtColor();
        ctx.fillRect(0, 0, size, size);
        if (document.fonts?.ready) await document.fonts.ready;
        const rects = {
          front: parseUvRect(model3dUv, [0.12, 0.20, 0.38, 0.48]),
          back: parseUvRect(model3dBackUv, [0.62, 0.18, 0.89, 0.48])
        };
        for (const side of ['front', 'back']) {
          const [u0, v0, u1, v1] = rects[side];
          const w = (u1 - u0) * size;
          const h = (v1 - v0) * size;
          await withSideVisible(side, async () => {
            const zone = zoneFor(side);
            if (!zone || !zone.offsetWidth || !zone.offsetHeight) {
              throw new Error('The print zone is not measurable. Reopen the design editor.');
            }
            // Crop in the editor coordinate system first. Redrawing directly into
            // the UV rectangle changes image containment and rotated edge cuts.
            const zoneCanvas = document.createElement('canvas');
            const scale = Math.min(4096 / Math.max(zone.offsetWidth, zone.offsetHeight),
              Math.max(w / zone.offsetWidth, h / zone.offsetHeight, 1));
            zoneCanvas.width = Math.max(1, Math.round(zone.offsetWidth * scale));
            zoneCanvas.height = Math.max(1, Math.round(zone.offsetHeight * scale));
            const zoneCtx = zoneCanvas.getContext('2d');
            if (!zoneCtx) throw new Error('Could not render the print zone.');
            // The canvas boundary clips all layers once, exactly at the zone edges.
            await drawDesignLayers(side, zoneCtx, zoneCanvas.width, zoneCanvas.height);
            ctx.drawImage(zoneCanvas, u0 * size, v0 * size, w, h);
          });
        }
        return c.toDataURL('image/png');
      };

      let designTextureRevision = 0;
      let textureUpdateTask = null;
      const applyDesignToModel = () => {
        ++designTextureRevision;
        if (!mv3dModel?.model) return Promise.resolve();
        if (textureUpdateTask) return textureUpdateTask;
        textureUpdateTask = (async () => {
          let applied = -1;
          while (applied !== designTextureRevision) {
            const revision = designTextureRevision;
            const dataUrl = await renderDesignTexture();
            if (revision !== designTextureRevision) continue;
            const texture = await mv3dModel.createTexture(dataUrl);
            if (revision !== designTextureRevision) continue;
            for (const material of mv3dModel.model.materials) {
              const pbr = material.pbrMetallicRoughness;
              // The canvas contains the garment colour AND artwork. White factor avoids tinting the artwork.
              pbr.setBaseColorFactor([1, 1, 1, 1]);
              pbr.setMetallicFactor(0);
              pbr.setRoughnessFactor(0.85);
              pbr.baseColorTexture.setTexture(texture);
            }
            applied = revision;
          }
        })().catch((error) => {
          console.warn('[Mindvey Tee] 3D preview update failed:', error);
          if (formStatus) formStatus.textContent = 'The 3D artwork preview could not update. Please reopen the preview and try again.';
        }).finally(() => { textureUpdateTask = null; });
        return textureUpdateTask;
      };

      root.querySelectorAll('[data-product-option]').forEach((button) => {
        button.addEventListener('click', () => {
          if (mv3dLoaded && mv3dPanel && !mv3dPanel.hidden) applyDesignToModel();
        });
      });

      const ensureModelViewerLoaded = () => {
        if (window.customElements && customElements.get('model-viewer')) return Promise.resolve();
        if (window.__mvModelViewerPromise) return window.__mvModelViewerPromise;
        window.__mvModelViewerPromise = new Promise((resolve, reject) => {
          const s = document.createElement('script');
          s.type = 'module';
          s.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js';
          const timer = setTimeout(() => { s.remove(); reject(new Error('3D viewer script timed out')); }, 20000);
          s.onload = () => { clearTimeout(timer); resolve(); };
          s.onerror = () => { clearTimeout(timer); s.remove(); reject(new Error('3D viewer script could not load')); };
          document.head.appendChild(s);
        }).catch((error) => { window.__mvModelViewerPromise = null; throw error; });
        return window.__mvModelViewerPromise;
      };

      const load3dView = async () => {
        if (!mv3dPanel) return;

        if (!enable3d || !model3dUrl) {
          if (mv3dComingSoon) mv3dComingSoon.hidden = false;
          if (mv3dModel) mv3dModel.hidden = true;
          if (mv3dLoading) mv3dLoading.hidden = true;
          return;
        }

        if (mv3dLoaded && mv3dModel && mv3dModel.model) {
          await applyDesignToModel();
          return;
        }

        if (mv3dModel && mv3dModel.dataset.loading === 'true') return;
        if (mv3dModel) mv3dModel.dataset.loading = 'true';

        if (mv3dComingSoon) mv3dComingSoon.hidden = true;
        if (mv3dLoading) mv3dLoading.hidden = false;

        try {
          await ensureModelViewerLoaded();
          if (!mv3dModel) {
            if (mv3dModel) mv3dModel.dataset.loading = 'false';
            return;
          }

          if (model3dAutoRotate) mv3dModel.setAttribute('auto-rotate', '');
          else mv3dModel.removeAttribute('auto-rotate');
          mv3dModel.setAttribute('rotation-per-second', model3dAutoRotate ? '18deg' : '0deg');
          if (model3dCameraMode === 'horizontal') {
            mv3dModel.setAttribute('min-camera-orbit', 'auto 80deg auto');
            mv3dModel.setAttribute('max-camera-orbit', 'auto 100deg auto');
          } else {
            mv3dModel.removeAttribute('min-camera-orbit');
            mv3dModel.removeAttribute('max-camera-orbit');
          }
          mv3dModel.hidden = false;

          let loadTimer;
          const onLoad = async () => {
            clearTimeout(loadTimer);
            mv3dModel.removeEventListener('load', onLoad);
            mv3dModel.removeEventListener('error', onError);
            mv3dLoaded = true;
            mv3dModel.dataset.loading = 'false';
            if (mv3dLoading) mv3dLoading.hidden = true;
            requestAnimationFrame(async () => { await applyDesignToModel(); });
          };
          const onError = () => {
            clearTimeout(loadTimer);
            mv3dModel.hidden = true;
            mv3dModel.removeEventListener('error', onError);
            mv3dModel.removeEventListener('load', onLoad);
            mv3dModel.dataset.loading = 'false';
            if (mv3dLoading) mv3dLoading.hidden = true;
            if (mv3dComingSoon) {
              mv3dComingSoon.hidden = false;
              const s = mv3dComingSoon.querySelector('strong');
              const p = mv3dComingSoon.querySelector('p');
              if (s) s.textContent = 'Could not load 3D model';
              if (p) p.textContent = 'Check the GLB file URL in the studio settings, then reopen the 3D tab to retry.';
            }
          };
          mv3dModel.addEventListener('load', onLoad, { once: true });
          mv3dModel.addEventListener('error', onError, { once: true });
          if (mv3dModel.model) await onLoad();
          else {
            loadTimer = setTimeout(onError, 30000);
            mv3dModel.removeAttribute('src');
            mv3dModel.setAttribute('src', model3dUrl);
          }
        } catch (err) {
          if (mv3dModel) mv3dModel.dataset.loading = 'false';
          if (mv3dLoading) mv3dLoading.hidden = true;
          if (mv3dComingSoon) {
            mv3dComingSoon.hidden = false;
            mv3dComingSoon.querySelector('strong').textContent = 'Could not load 3D preview';
            mv3dComingSoon.querySelector('p').textContent = 'Check your connection and GLB file URL, then reopen the 3D tab to retry.';
          }
          console.warn('[Mindvey Tee] 3D viewer failed to load:', err);
        }
      };

      const fitPreviewCanvas = () => {
        if (!previewClone || !previewCanvasSize || !finalPreviewArt) return;
        const hostW = Math.max(1, finalPreviewArt.clientWidth - 36);
        const hostH = Math.max(1, finalPreviewArt.clientHeight - 36);
        const scale = Math.min(hostW / previewCanvasSize.width, hostH / previewCanvasSize.height, 1);
        previewClone.style.transform = `scale(${scale})`;
        previewClone.style.transformOrigin = 'center center';
      };

      const showPreviewSide = (side) => {
        const is3d = side === '3d';
        const nextSide = side === 'back' ? 'back' : 'front';

        if (mv3dPanel) mv3dPanel.hidden = !is3d;

        if (finalPreviewArt) {
          const artParent = finalPreviewArt.closest('.mv-tee-final-preview__single');
          if (artParent) artParent.hidden = is3d;

          if (!is3d && previewClone) {
            previewClone.querySelectorAll('[data-side]').forEach((view) => {
              view.hidden = view.dataset.side !== nextSide;
            });
            requestAnimationFrame(() => fitPreviewCanvas());
          }
        }

        finalPreviewTabs.forEach((tab) => {
          const active = tab.dataset.finalPreviewSide === side;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        if (is3d) load3dView();
      };

      const openFinalPreview = () => {
        if (!finalPreviewModal || !finalPreviewArt) return;
        const sourceCanvas = root.querySelector('[data-canvas]');
        if (!sourceCanvas) return;

        finalPreviewPreviousFocus = document.activeElement;
        previewOriginalSide = activeSide;

        const width = Math.max(1, sourceCanvas.offsetWidth);
        const height = Math.max(1, sourceCanvas.offsetHeight);
        previewCanvasSize = { width, height };

        previewClone = sourceCanvas.cloneNode(true);
        previewClone.removeAttribute('id');
        previewClone.classList.add('mv-tee-final-preview-canvas');
        previewClone.style.width = `${width}px`;
        previewClone.style.height = `${height}px`;
        previewClone.style.maxWidth = 'none';
        previewClone.style.maxHeight = 'none';
        previewClone.style.minWidth = '0';
        previewClone.style.minHeight = '0';
        previewClone.style.aspectRatio = 'auto';
        previewClone.style.margin = '0';
        previewClone.style.position = 'relative';
        previewClone.style.left = 'auto';
        previewClone.style.top = 'auto';
        previewClone.style.right = 'auto';
        previewClone.style.bottom = 'auto';
        previewClone.style.transform = 'none';
        previewClone.style.flex = '0 0 auto';
        previewClone.style.pointerEvents = 'none';

        previewClone.querySelectorAll('.mv-tee-layer').forEach((layer) => {
          layer.classList.remove('is-selected');
          layer.querySelectorAll('.mv-tee-handle, .mv-tee-frame').forEach((handle) => handle.remove());
          layer.style.pointerEvents = 'none';
        });
        previewClone.querySelectorAll('[data-zone]').forEach((zone) => {
          zone.style.pointerEvents = 'none';
        });

        finalPreviewModal.hidden = false;
        finalPreviewModal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('mv-tee-preview-open');
        finalPreviewArt.replaceChildren(previewClone);
        showPreviewSide(activeSide);
        syncDesignManifest();

        requestAnimationFrame(() => {
          fitPreviewCanvas();
          finalPreviewModal.querySelector('.mv-tee-final-preview__close')?.focus();
        });
      };

      const closeFinalPreview = () => {
        if (!finalPreviewModal) return;
        clearPreview();
        setSide(previewOriginalSide);
        finalPreviewModal.hidden = true;
        finalPreviewModal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('mv-tee-preview-open');
        if (finalPreviewPreviousFocus && typeof finalPreviewPreviousFocus.focus === 'function') finalPreviewPreviousFocus.focus();
        finalPreviewPreviousFocus = null;
      };

      finalPreviewTabs.forEach((tab) => {
        tab.addEventListener('click', () => showPreviewSide(tab.dataset.finalPreviewSide));
      });
      window.addEventListener('resize', () => {
        if (finalPreviewModal && !finalPreviewModal.hidden) fitPreviewCanvas();
      });
      finalPreviewButton?.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); openFinalPreview(); });
      finalPreviewModal?.querySelectorAll('[data-final-preview-close]').forEach((button) => button.addEventListener('click', closeFinalPreview));
      finalPreviewConfirm?.addEventListener('click', () => { closeFinalPreview(); });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && finalPreviewModal && !finalPreviewModal.hidden) closeFinalPreview();
      });

      renderLibrary();
      updateEditorTotal();
    });

    // ---- Modal + inline logic ----
    const modalWrap = document.querySelector('[data-mv-modal-wrap]');
    if (modalWrap && !modalWrap.dataset.modalBound) {
      modalWrap.dataset.modalBound = "true";
      const root = modalWrap.querySelector('.mv-tee-app');
      const hasProduct = root && root.dataset.productId;
      const params = new URLSearchParams(window.location.search);
      const wantsOpenViaQuery = params.get('customize') === '1';

      const isProductPage = /^\/products\//.test(window.location.pathname);
      const modalMode = isProductPage && hasProduct && !wantsOpenViaQuery;

      if (modalMode) {
        modalWrap.classList.add('is-modal');
      }

      let closeBtn = modalWrap.querySelector('.mv-tee-modal-wrap__close');
      if (!closeBtn) {
        closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.className = 'mv-tee-modal-wrap__close';
        closeBtn.setAttribute('aria-label', 'Close customizer');
        closeBtn.innerHTML = '×';
        closeBtn.hidden = true;
        modalWrap.appendChild(closeBtn);
      }

      const openModal = () => {
        modalWrap.classList.add('is-modal');
        modalWrap.classList.add('is-open');
        closeBtn.hidden = false;
        document.body.classList.add('mv-tee-modal-open');
        modalWrap.setAttribute('tabindex', '-1');
        modalWrap.focus({ preventScroll: true });
        modalWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      const closeModal = () => {
        modalWrap.classList.remove('is-open');
        closeBtn.hidden = true;
        document.body.classList.remove('mv-tee-modal-open');
      };

      closeBtn.addEventListener('click', closeModal);
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modalWrap.classList.contains('is-open')) closeModal();
      });

      document.querySelectorAll('[data-customize-trigger]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          openModal();
        });
      });

      if (wantsOpenViaQuery) {
        requestAnimationFrame(() => {
          openModal();
          try { window.history.replaceState({}, '', window.location.pathname); } catch (e) {}
        });
      }
    }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initStudios, { once: true });
    else initStudios();
    document.addEventListener('shopify:section:load', initStudios);
  })();

  } catch(e) { console.error(e); }
})();
})();
